export const common = {
  // Top Bar
  topBar: {
    freeShipping: 'SPEDIZIONE GRATUITA - Su tutti gli ordini',
    newMemberDiscount: '10% di sconto per i nuovi membri',
    securePayment: 'Acquisto sicuro',
  },

  // Navigation
  nav: {
    home: 'Home',
    women: 'DONNA',
    men: 'UOMO',
    blog: 'BLOG',
    superSale: 'SUPER SALDI',
    memberLogin: 'Accesso membri',
    login: 'Accedi',
    register: 'Registrati',
    myOrders: 'I miei ordini',
    myFavorites: 'I miei preferiti',
    myCart: 'Il mio carrello',
    pages: 'Pagine',
    preferences: 'Preferenze',
    myProfile: 'Il mio profilo',
  },

  megaMenu: {
    womenCollection: 'Collezione Donna',
    menCollection: 'Collezione Uomo',
    summerCollection: 'Collezione Estate 2025',
    viewAll: 'Vedi tutto',
    categories: 'CATEGORIE',
    newSeason: 'NUOVA STAGIONE',
    upToDiscount: 'Fino al 70% di sconto',
    exploreAll: 'Esplora l\'intera collezione',
    viewAllBtn: 'Vedi tutto',
    securePayment: 'Pagamento sicuro',
    sslNote: 'Tutti i tuoi pagamenti sono crittografati e sicuri.',
    sslBadge: '256-bit SSL',
    quickTags: {
      newArrivals: 'Nuovi arrivi',
      bestSelling: 'Più venduti',
      discounted: 'Scontati',
      specialDesign: 'Design speciale',
    },
    womenSandals: 'Sandali Donna', womenSandalsDesc: 'Collezione estiva',
    womenClothing: 'Abbigliamento Donna', womenClothingDesc: 'Pezzi di tendenza',
    womenShoes: 'Scarpe Donna', womenShoesDesc: 'Per ogni stile',
    womenBoots: 'Stivali Donna', womenBootsDesc: 'Chic & robusto',
    womenSlippers: 'Pantofole Donna', womenSlippersDesc: 'Comodo & elegante',
    womenBags: 'Borse Donna', womenBagsDesc: 'Preferiti della stagione',
    womenAccessories: 'Accessori Donna', womenAccessoriesDesc: 'Pezzi complementari',
    womenCombo: 'Combo Donna', womenComboDesc: 'Set completi',
    menSandals: 'Sandali Uomo', menSandalsDesc: 'Collezione estiva',
    menClothing: 'Abbigliamento Uomo', menClothingDesc: 'Stili moderni',
    menShoes: 'Scarpe Uomo', menShoesDesc: 'Classico & sportivo',
    menBoots: 'Stivali Uomo', menBootsDesc: 'Forte & elegante',
    menSlippers: 'Pantofole Uomo', menSlippersDesc: 'Comfort quotidiano',
    menBags: 'Borse Uomo', menBagsDesc: 'Lavoro & casual',
    menAccessories: 'Accessori Uomo', menAccessoriesDesc: 'Dettagli di stile',
    menCombo: 'Combo Uomo', menComboDesc: 'Set completi',
    comboBadge: 'Combo',
    tshirt: 'T-Shirt', pants: 'Pantaloni', dress: 'Vestito', kimono: 'Kimono',
    crop: 'Crop', shirt: 'Camicia', skirt: 'Gonna', shorts: 'Shorts', suit: 'Completo',
    womenLabel: 'Donna', menLabel: 'Uomo', collectionSuffix: 'Collezione',
  },

  settings: {
    language: 'Lingua',
    currency: 'Valuta',
    selectLanguage: 'Seleziona lingua',
    selectCurrency: 'Seleziona valuta',
  },

  topBarMessages: {
    msg1: 'SPEDIZIONE GRATUITA - Su tutti gli ordini | 10% di sconto per i nuovi membri',
    msg2: 'SCARPE BAREFOOT DI MESSA A TERRA ORGANICA STIVALI SANDALI',
    msg3: 'È ORA DI VIVERE LA MODA ORGANICA — SCOPRI LA NATURALITÀ',
    msg4: 'SUPER COMBO — NON PERDERE I REGALI SORPRESA PRIMA CHE FINISCA LO STOCK',
  },

  quickMenu: {
    title: 'Accesso rapido',
    liveChat: 'Chat dal vivo',
    liveChatStatus: 'Attivo ora ✓',
    liveSupport: 'Supporto live',
    liveSupportStatus: 'Attivo ora',
    liveCall: 'Chiamata dal vivo',
    liveCallDesc: 'Supporto vocale',
    liveBroadcast: 'Diretta streaming',
    liveBroadcastStatus: 'In diretta ora 🔴',
    liveBroadcastBadge: 'LIVE',
    sustainability: 'Sostenibilità',
    sustainabilityDesc: '100% Biologico 🌿',
    support247: 'Assistenza clienti 24/7',
    scrollUp: 'Scorri su',
    menu: 'MENU',
    up: 'SU',
    dayMode: 'Giorno',
    nightMode: 'Notte',
    socialMedia: 'Social Media',
    pages: 'Pagine',
    support: 'Supporto',
    followUs: 'Seguici',
    wholesale: 'Prodotti Ingrosso',
  },

  search: {
    placeholder: 'Cerca prodotti... (es. sandali, stivali, vestito)',
    noResults: 'Nessun risultato trovato',
    viewAll: 'Vedi tutti i prodotti "{{query}}"',
    title: 'Cerca',
    shortLabel: 'Cerca',
    close: 'Chiudi',
    popular: 'Ricerche popolari',
    resultsLabel: 'Prodotti trovati',
    popularTerms: ['Sandali', 'Stivali', 'Vestito', 'Pantofole', 'Combo'],
    searchPage: {
      resultsCount: 'prodotti trovati',
      searchDesc: 'Trova il prodotto che stai cercando',
      sortBy: 'Ordina per',
      sortDefault: 'Predefinito',
      sortPriceLow: 'Prezzo: Basso ad Alto',
      sortPriceHigh: 'Prezzo: Alto a Basso',
      sortDiscount: 'Sconto più alto',
      viewProduct: 'Vedi il prodotto',
      tryOtherTerms: 'Prova un altro termine di ricerca',
      loadMore: 'Carica altro',
    },
  },

  popularProductsNav: 'Prodotti popolari',

  header: { shopNow: 'Acquista Ora' },

  home: {
    bestSeller: 'PIÙ VENDUTI',
    specialCampaign: 'CAMPAGNA SPECIALE',
    featuredCombos: 'Set Combo in Evidenza',
    featuredProducts: 'Prodotti in Evidenza',
    exploreCategories: 'Esplora le Categorie',
    viewAllProducts: 'Vedi Tutti i Prodotti',
    viewAllCombos: 'Vedi Tutti i Combo',
    setContent: 'CONTENUTO DEL SET',
    normalPrice: 'Prezzo Normale',
    comboPrice: 'Prezzo Combo',
    save: 'RISPARMIO',
    freeShippingBadge: 'Spedizione Gratuita',
    viewDetails: 'Vedi Dettagli',
    whereToNextLabel: 'Collezioni',
    whereToNextTitle: 'Prossima Destinazione?',
    whereToNextSubtitle: 'L\'unica scarpa di cui hai bisogno per il tuo viaggio!',
    whereToNextShop: 'Vedi prodotto',
    whereToNextBuy: 'ACQUISTA ORA',
    flashSaleLabel: 'Vendita Flash',
    flashSaleTitle: 'Fino al 70% di Sconto',
    flashSaleSubtitle: 'Stock limitato — approfittane subito!',
    flashSaleViewAll: 'Vedi tutto',
    flashSaleTimeLabel: 'La vendita termina tra',
    flashSaleHour: 'Ora',
    flashSaleMinute: 'Minuto',
    flashSaleSecond: 'Secondo',
    flashSaleNext: 'Prossimo:',
    flashSaleRound: 'Round',
    flashSaleStockRunning: 'Scorte in esaurimento',
    flashSaleSold: 'Venduto',
    flashSaleBuy: 'Acquista',
    flashSaleNewCampaign: 'Nuova vendita iniziata!',
    flashSaleNewCampaignSub: 'Non perdere!',
    comboPacksTitle: 'Pacchi Combo',
    comboPacksSubtitle: 'Risparmia tempo e denaro con combo già pronti',
    comboPacksIn: 'Include:',
    comboPacksSaving: 'di risparmio!',
    comboPacksViewAll: 'Vedi tutti i combo',
    exploreCategoriesLabel: 'Collezioni',
    exploreCategoriesSubtitle: 'Scegli la collezione che si adatta al tuo stile',
    categoriesSubtitle: 'Scegli la categoria adatta a te',
    // Category Cards
    catSlippers: 'Pantofole',
    catSlippersSub: 'Modelli Comodi & Eleganti',
    catSandals: 'Sandali',
    catSandalsSub: 'Modelli con Tacco & Piatti',
    catCombos: 'Outfit',
    catCombosSub: 'Combo 1+1 a partire da $500',
    catDresses: 'Vestiti',
    catDressesSub: 'Modelli Maxi, Midi & Mini',
    catVeganLeather: 'Pelle Vegana',
    catVeganLeatherSub: 'Collezione Cruelty-Free',
    catGenuineLeather: 'Pelle Vera',
    catGenuineLeatherSub: 'Prodotti in Pelle Animale Premium',
    catBadgeVegan: 'VEGAN',
    catBadgePremium: 'PREMIUM',
    recentReviewsTitle: 'Recensioni Recenti dei Clienti',
    recentReviewsSubtitle: 'Ultime recensioni da acquirenti reali',
    recentReviewsViewAll: 'Tutte le recensioni',
    recentReviewsAvgScore: 'Punteggio Medio',
    recentReviewsTotal: 'Recensioni Totali',
    recentReviewsVerified: 'Acquirente Verificato',
    recentReviewsVerifiedBadge: 'Verificato',
    recentReviewsSizeLabel: 'Taglia:',
    // Spring Banner
    springBannerSubtitle: 'Esplora le nuove collezioni stagionali e completa il tuo stile',
    springCollectionsLabel: 'Collezioni',
    // Video Banner
    videoBannerLabel: 'Preferiti dei Clienti',
    videoBannerTitle: 'Prodotti Più Apprezzati',
    videoBannerSubtitle: 'I nostri prodotti più amati e meglio recensiti',
    videoBannerViewAll: 'Visualizza pagina completa',
    videoBannerCta: 'Esplora la nostra filosofia sostenibile',
    videoBannerCertsLabel: 'Le nostre certificazioni',
    videoBannerCarbonLabel: 'Impronta di Carbonio',
    videoBannerCarbonVal: 'Zero Emissioni',
    // Hero
    heroStartingFrom: 'A Partire Da',
    // Blog Preview
    blogBadge: 'Blog',
    blogTitle: 'Ultimi Articoli',
    blogSubtitle: 'Contenuti ispiratori su salute, moda e sostenibilità',
    blogViewAll: 'Vedi tutti gli articoli',
    blogReadMore: 'Continua a leggere',
    blogReadTime: 'min di lettura',
    // Sustainability Banner
    sustBannerBadge: 'Moda Sostenibile',
    sustBannerTitle: 'Siamo difensori di',
    sustBannerTitleHighlight: 'Sostenibilità & Bio',
    sustBannerDesc: "Ogni cucitura, ogni tintura, ogni materiale — è espressione del nostro rispetto per il pianeta e per voi. Dal cotone biologico certificato GOTS alle tinture botaniche — siamo in armonia con la natura.",
    sustBannerStat1Label: 'Meno Acqua',
    sustBannerStat2Label: 'Materiali Bio',
    sustBannerStat3Label: 'Coloranti Chimici',
    sustBannerCta1: 'La nostra pagina sostenibilità',
    sustBannerCta2: 'Collezione Bio',
    // Sustainability Preview
    sustPreviewBadge: 'Sostenibilità',
    sustPreviewTitle: 'Dalla Natura,',
    sustPreviewTitleHighlight: 'Ritorno alla Natura',
    sustPreviewSubtitle: "Ogni materiale, ogni fase di produzione e ogni confezione è prova del nostro rispetto per l'ambiente e la salute umana.",
    sustPreviewViewAll: 'Visualizza pagina completa',
    sustPreviewCta: 'Esplora la nostra filosofia sostenibile',
    sustPreviewCertsLabel: 'Le nostre certificazioni',
    sustPreviewCarbonLabel: 'Impronta di Carbonio',
    sustPreviewCarbonVal: 'Zero Emissioni',
    // PC Slider
    pcSlide1Tag: '⚡ NUOVA COLLEZIONE',
    pcSlide1Title: "Sogno d'Estate",
    pcSlide1TitleHighlight: 'Collezione',
    pcSlide1Subtitle: 'Sandali in pelle premium che portano il calore del Mediterraneo ai tuoi piedi',
    pcSlide2Tag: '🔥 70% DI SCONTO',
    pcSlide2Title: 'Boho Chic',
    pcSlide2TitleHighlight: 'Abiti Estivi',
    pcSlide2Subtitle: 'Collezione boho artigianale che riflette il tuo spirito libero — stock limitato',
    pcSlide3Tag: '🌿 PELLE VEGANA',
    pcSlide3Title: 'Sostenibile',
    pcSlide3TitleHighlight: 'Moda Lusso',
    pcSlide3Subtitle: 'Collezione di pelle vegana premium, rispettosa della natura e cruelty-free',
    pcSlide4Tag: '🍂 NUOVA COLLEZIONE',
    pcSlide4Title: 'Autunno',
    pcSlide4TitleHighlight: 'Collezione Stivali',
    pcSlide4Subtitle: "Senti lo spirito dell'autunno con stivali artigianali in pelle premium — stock limitato",
    pcSlide4Cta1: 'Stivali Donna',
    pcSlide4Cta2: 'Stivali Uomo',
    // Mobile Slider
    mobileSlide1Title: '65% Sconto Moda Estiva',
    mobileSlide1Subtitle: 'Fino al 70% di Sconto sugli Outfit Estivi',
    mobileSlide2Title: 'Nuova Collezione',
    mobileSlide2Subtitle: 'Modelli di Sandali & Pantofole in Pelle Premium',
    mobileSlide3Title: 'Collezione Autunno',
    mobileSlide3Subtitle: 'Stivali in Pelle Artigianali — Stock Limitato',
    // Promo Banner
    promoTitle: 'Combo 1+1',
    promoTitleHighlight: '70% di Sconto',
    promoSavings: 'Risparmia $1.800!',
    promoCta: 'Esplora i Combo',
    promoDiscountBadge: '70% RISPARMIO',
    // Square Banners
    squareBanner1Label: 'NUOVA COLLEZIONE',
    squareBanner1Title: 'Collezione\nEstiva',
    squareBanner2Label: 'PIÙ VENDUTI',
    squareBanner2Title: 'Collezione\nPantofole',
    squareBanner3Label: 'TENDENZA ESTATE',
    squareBanner3Title: 'Collezione\nSandali',
    squareBanner4Label: 'AUTUNNO',
    squareBanner4Title: 'Collezione\nStivali',
    // Editorial Banners
    editorialBannersLabel: 'Le Nostre Collezioni',
    editorialBannersTitle: 'Sabah Season is Coming',
    editorialBanner2Label: 'Più Venduti',
    editorialBanner2Title: 'Pattern Babas',
    editorialBanner2Subtitle: 'Di ritorno per Primavera',
    editorialBanner3Label: 'Viaggio',
    editorialBanner3Title: 'Prossima Destinazione?',
    editorialBanner3Subtitle: "La costa nord di O'ahu",
    editorialBanner4Label: 'Fatto a Mano',
    editorialBanner4Title: 'The Lido Sandal',
    editorialBanner4Subtitle: 'Fatto a mano in Italia',
  },

  footer: {
    categories: 'Categorie',
    customerService: 'Servizio Clienti',
    followUs: 'Seguici',
    wholesale: 'Vendita all\'Ingrosso',
    returnPolicyBtn: 'Reso & Cambio',
    securePaymentTitle: 'Pagamento Sicuro',
    shippingPartnerTitle: 'Partner di Spedizione',
    fastDelivery: 'Consegna Rapida',
    securityTitle: 'Sicurezza',
    encryptedShopping: 'Acquisto Crittografato',
    httpsSecure: 'HTTPS Sicuro',
    intlShippingTitle: 'Paesi — Spedizione Internazionale',
    intlShippingDesc: 'Consegna rapida e sicura in tutto il mondo — tracciamento ordine incluso',
    cargoPartner: 'Partner di Spedizione',
    countries: 'Paesi',
    businessDaysLabel: 'Giorni Lavorativi',
    trackingLabel: 'Tracciamento',
    marketplaceTitle: 'Vendiamo sui Mercati Internazionali',
    mobileShippingTitle: 'Paesi Spedizione Sicura',
    mobileShippingSubtitle: 'Tracciamento ordine · 3–7 giorni lavorativi',
    mobileCargo: 'Cargo',
    mobileMarketplaceTitle: 'Mercati Internazionali',
    newsletterTitle: 'Iscriviti alla nostra newsletter',
    newsletterSubtitle: 'Sii il primo a sapere delle nuove collezioni, offerte esclusive e promozioni speciali.',
    newsletterPlaceholder: 'Inserisci il tuo indirizzo email',
    newsletterSubscribe: 'Iscriviti',
    newsletterSuccess: 'Grazie! Ti sei iscritto con successo. 🎉',
    newsletterPrivacy: 'I tuoi dati sono al sicuro. Puoi annullare l\'iscrizione in qualsiasi momento.',
  },

  category: {
    filter: 'Filtra',
    productsFound: 'prodotti trovati',
    page: 'Pagina',
    otherCategories: 'Altre Categorie',
    showingProducts: 'prodotti visualizzati',
    of: 'di',
    subcat: {
      all: 'Tutto', boots: 'Stivali', clothing: 'Abbigliamento', shoes: 'Scarpe', sandals: 'Sandali', slippers: 'Pantofole', bags: 'Borse', accessories: 'Accessori', combo: 'Set Combo', tshirt: 'T-Shirt', pants: 'Pantaloni', dress: 'Vestito', kimono: 'Kimono', crop: 'Crop', shirt: 'Camicia', skirt: 'Gonna', shorts: 'Pantaloncini', suit: 'Completo', set: 'Set',
    },
    meta: {
      women: 'Donna', womenClothing: 'Abbigliamento Donna', womenSandals: 'Sandali Donna', womenSlippers: 'Pantofole Donna', womenShoes: 'Scarpe Donna', womenBags: 'Borse Donna', womenAccessories: 'Accessori Donna', womenBoots: 'Stivali Donna', womenCombo: 'Set Donna',
      tshirt: 'T-Shirt', pants: 'Pantaloni', dress: 'Vestito', kimono: 'Kimono', crop: 'Crop', shirt: 'Camicia', skirt: 'Gonna', shorts: 'Pantaloncini', suit: 'Completo', set: 'Set',
      men: 'Uomo', menClothing: 'Abbigliamento Uomo', menSandals: 'Sandali Uomo', menSlippers: 'Pantofole Uomo', menShoes: 'Scarpe Uomo', menBags: 'Borse Uomo', menAccessories: 'Accessori Uomo', menBoots: 'Stivali Uomo', menCombo: 'Set Uomo',
      menTshirt: 'T-Shirt Uomo', menPants: 'Pantaloni Uomo', menShirt: 'Camicia Uomo', menShorts: 'Pantaloncini Uomo', menSuit: 'Completo Uomo',
      veganLeather: 'Pelle Vegana', genuineLeather: 'Pelle Vera', combo: 'Combo',
    },
  },

  productPage: {
    notFound: 'Prodotto non trovato',
    backToHome: 'Torna alla home',
    reviews: 'recensioni',
    inStock: 'Disponibile',
    save: 'Risparmia',
    comboContent: 'Contenuto combo',
    youSave: 'risparmi',
    selectSize: 'Seleziona taglia',
    sizeGuide: 'Guida alle taglie',
    shoeSize: 'Seleziona numero (US)',
    shoeSizeGuide: 'Guida ai numeri',
    quantity: 'Quantità',
    addToCart: 'Aggiungi al carrello',
    added: 'Aggiunto!',
    selectOptions: 'Effettua una selezione!',
    buyNow: 'Acquista ora',
    freeShipping: 'Spedizione gratuita',
    dayReturn: 'Reso 30 giorni',
    securePayment: 'Pagamento sicuro',
    productDescription: 'Descrizione prodotto',
    features: 'Caratteristiche',
    similarProducts: 'Prodotti simili',
    zoom: 'Zoom',
    zoomHint: 'Doppio clic o scorri per ingrandire',
    shopAnywhere: 'Acquista questo prodotto ovunque',
    customerReviews: 'Recensioni clienti',
    addedToCart: 'Prodotto aggiunto al carrello!',
    viewCart: 'Vedi carrello',
    home: 'Home',
    personalization: 'Personalizzazione & Confezione regalo',
    personalizationNote: 'Aggiungi nota, scegli confezione regalo',
    personalizationActive: 'Attivo',
    shippingOption: 'Opzione di spedizione',
    freeShippingLabel: 'Spedizione gratuita',
    freeLabel: 'GRATUITO',
    estimatedDelivery: 'Consegna stimata:',
    businessDays: '(6 giorni lavorativi)',
    customsTax: 'Dazio doganale:',
    noExtraFee: 'Nessun costo extra, tutte le tasse incluse!',
    returnPolicy: 'Politica di Reso & Cambio',
    returnPolicyTitle: 'Politica di Reso & Cambio',
    returnPolicyClose: 'Chiudi',
    returnPolicy30Days: 'Diritto di reso 30 giorni',
    returnPolicy30DaysDesc: 'Puoi restituire il tuo ordine entro 30 giorni dalla consegna.',
    returnPolicyFreeReturn: 'Reso gratuito',
    returnPolicyFreeReturnDesc: 'Copriamo tutte le spese di restituzione per te.',
    returnPolicyRefundTime: 'Rimborso in 5-7 giorni lavorativi',
    returnPolicyRefundTimeDesc: 'Il tuo pagamento sarà rimborsato entro 5-7 giorni lavorativi.',
    returnPolicyExchange: 'Cambio facile',
    returnPolicyExchangeDesc: 'Cambio gratuito disponibile per modifiche di taglia o colore.',
    returnPolicyNote: 'Resi e cambi validi per prodotti non utilizzati nella confezione originale con etichette attaccate.',
    sole: 'Suola',
    usSize: 'Taglia',
    fitOption: 'Opzione di vestibilità',
    wideFitLabel: 'Vestibilità ampia',
    wideFitDesc: 'Taglio comodo e rilassato',
    narrowFitLabel: 'Vestibilità slim',
    narrowFitDesc: 'Taglio aderente e slim',
    personalizationInlineTitle: 'Personalizzazione',
    personalizationInlineLine1: 'Puà essere indossato senza calze, comodo e sano.',
    personalizationInlineLine2: "Per misurazioni accurate, puoi scrivere le misure del tuo piede scalzo (lunghezza e larghezza) in centimetri in quest'area. Esempio (24,5 CM x 9 CM)",
    personalizationInlineLine3: 'Verrà prodotto come desideri, largo o stretto.',
  },

  superSale: {
    limitedTime: 'Campagna a tempo limitato',
    live: 'LIVE',
    timeRemaining: 'Tempo rimanente',
    all: 'Tutto',
    women: 'Donna',
    men: 'Uomo',
    womenCombo: 'Combo Donna',
    menCombo: 'Combo Uomo',
    sortBy: 'Ordina per',
    priceAsc: 'Prezzo: Basso ad Alto',
    priceDesc: 'Prezzo: Alto a Basso',
    discountDesc: 'Sconto: Alto a Basso',
    newest: 'Più recente',
    productsOnSale: 'Prodotti in saldo',
    totalDiscount: 'Sconto totale',
    happyCustomers: 'Clienti felici',
    freeShipping: 'Spedizione gratuita',
    banner1Title: 'Migliori offerte della stagione',
    banner1Subtitle: 'Fino al 70% di sconto su tutte le categorie',
    banner2Title: 'Ultime ore!',
    banner2Subtitle: 'Aggiungi al carrello prima che finisca',
    flashRound: 'Vendita Flash',
    flashBadge: '⚡ FLASH',
    dailyRound: 'Offerta del Giorno',
    dailyBadge: '🔥 GIORNALIERO',
    nightRound: 'Campagna Notturna',
    nightBadge: '🌙 NOTTE',
    newCampaignStarted: 'Nuova campagna iniziata!',
    dontMiss: 'Non perdere!',
    nextCampaign: 'Prossimo:',
    hours: 'ORE',
    minutes: 'MINUTI',
    seconds: 'SECONDI',
    discount: 'SCONTO',
    reviews: 'recensioni',
    stockStatus: 'Stato scorte',
    stockLeft: 'articoli rimasti!',
  },

  combo: {
    title: 'Pacchi Combo',
    subtitle: 'Risparmia tempo e denaro con combo accuratamente preparati.',
    benefit1Title: 'Prezzo Conveniente',
    benefit1Desc: '20-30% più economico rispetto all\'acquisto separato',
    benefit2Title: 'Risparmio di Tempo',
    benefit2Desc: 'Esperienza di acquisto rapida con combo già pronti',
    benefit3Title: 'Prodotti Compatibili',
    benefit3Desc: 'Combo accuratamente selezionati da stilisti',
    comboBadge: 'Pacco Combo',
    discountBadge: 'Sconto',
    packageContains: 'Include:',
    savings: 'di risparmio!',
    filterAll: 'Tutto',
    filterWomen: 'Donna',
    filterMen: 'Uomo',
    giftProduct: 'Prodotto Regalo',
  },

  blog: {
    title: 'Blog & Contenuti',
    subtitle: 'Blog FentyBarefoot',
    heroSubtitle: 'Contenuti informativi sulla salute dei piedi, filosofia barefoot, moda sostenibile e altro ancora',
    all: 'Tutto',
    healthLife: 'Salute & Vita',
    fashionTrend: 'Moda & Tendenza',
    careCleaning: 'Cura & Pulizia',
    sustainability: 'Sostenibilità',
    productKnowledge: 'Info prodotto',
    readMore: 'Continua a leggere',
    newsletterTitle: 'Non perdere gli aggiornamenti del blog',
    newsletterDesc: 'Unisciti alla nostra lista email per rimanere aggiornato sui nuovi contenuti',
    newsletterPlaceholder: 'Il tuo indirizzo email',
    subscribe: 'Iscriviti',
    post1Title: 'Barefoot & Biologico — Vantaggi delle Scarpe di Messa a Terra',
    post1Excerpt: 'Le scarpe di messa a terra sono progettate per integrare la struttura naturale dei tuoi piedi, contribuendo alla tua salute. Il punto di incontro della filosofia barefoot e della vita biologica...',
    post1Category: 'Salute & Vita',
    post1Date: '15 giugno 2024',
    post1ReadTime: '8 min di lettura',
    post2Title: "Consigli per la cura delle scarpe in estate",
    post2Excerpt: 'Come proteggere e mantenere pulite le scarpe con il caldo? Consigli pratici per un uso duraturo...',
    post2Category: 'Cura & Pulizia',
    post2Date: '10 giugno 2024',
    post2ReadTime: '5 min di lettura',
    post3Title: 'Scegliere la scarpa giusta per la salute dei piedi',
    post3Excerpt: 'A cosa prestare attenzione nella scelta delle scarpe per proteggere la salute dei piedi? Consigli di esperti...',
    post3Category: 'Salute & Vita',
    post3Date: '5 giugno 2024',
    post3ReadTime: '6 min di lettura',
    post4Title: 'Cosa sono le scarpe Barefoot? Perché sceglierle?',
    post4Excerpt: 'Come si differenziano le scarpe barefoot da quelle tradizionali? Effetti sulla salute dei piedi e aree di utilizzo...',
    post4Category: 'Info prodotto',
    post4Date: '1 giugno 2024',
    post4ReadTime: '7 min di lettura',
    post5Title: 'Tendenze scarpe estate 2024',
    post5Excerpt: 'Quali modelli di scarpe spiccano questa estate? Palette di colori, dettagli di design e suggerimenti di stile...',
    post5Category: 'Moda & Tendenza',
    post5Date: '28 maggio 2024',
    post5ReadTime: '5 min di lettura',
    post6Title: 'Scarpe realizzate con materiali biologici',
    post6Excerpt: 'Moda sostenibile e processi produttivi eco-compatibili. Vantaggi e futuro dei materiali organici...',
    post6Category: 'Sostenibilità',
    post6Date: '22 maggio 2024',
    post6ReadTime: '6 min di lettura',
    post7Title: 'Scarpe Zero Drop: La Rivoluzione che Cambia la Tua Postura',
    post7Excerpt: 'Il design zero drop — nessuna differenza di altezza tra tallone e punta — supporta la postura naturale e riduce i dolori alla schiena, alle ginocchia e ai piedi. Ma questa differenza è davvero così importante?',
    post7Category: 'Info prodotto',
    post7Date: '12 marzo 2025',
    post7ReadTime: '6 min di lettura',
    post8Title: 'Scarpe a Larga Punta e il Loro Impatto sulla Salute dei Piedi',
    post8Excerpt: 'Le scarpe a punta stretta sono da decenni la principale causa di deformità dei piedi. Il design a larga punta consente alle dita di allargarsi naturalmente, risolvendo questo problema alla radice...',
    post8Category: 'Salute & Vita',
    post8Date: '5 febbraio 2025',
    post8ReadTime: '7 min di lettura',
    post9Title: 'Stivali da Escursione Barefoot: Libertà nella Natura',
    post9Excerpt: 'Camminare su sentieri di montagna, foreste e terreni naturali con stivali barefoot è un\'esperienza completamente diversa. Sensazione del terreno, leggerezza e biomeccanica sana sono possibili insieme?',
    post9Category: 'Info prodotto',
    post9Date: '18 gennaio 2026',
    post9ReadTime: '8 min di lettura',
    post10Title: 'Stivali di Grounding: L\'Energia della Terra ad Ogni Passo',
    post10Excerpt: 'Gli stivali di grounding con dettagli conduttori in rame aggiungono una nuova dimensione alle tue passeggiate. Anche in autunno e in inverno puoi camminare liberamente senza perdere l\'effetto grounding...',
    post10Category: 'Salute & Vita',
    post10Date: '3 ottobre 2025',
    post10ReadTime: '7 min di lettura',
    post11Title: 'Tendenze Scarpe Sostenibili 2026: I Materiali del Futuro',
    post11Excerpt: 'Pelle di cactus, micelio di funghi, pelle di pesce e suole biodegradabili... Le tendenze delle scarpe sostenibili 2026 non sono solo ecologiche ma anche perfettamente in linea con la filosofia barefoot...',
    post11Category: 'Sostenibilità',
    post11Date: '7 aprile 2026',
    post11ReadTime: '6 min di lettura',
    post12Title: 'Earthing e Qualità del Sonno: Cosa dice la Scienza?',
    post12Excerpt: 'L\'insonnia è uno dei problemi di salute più comuni della nostra era. Come la scienza dell\'earthing migliora la qualità del sonno? Ricerca sul ritmo del cortisolo, melatonina e cicli di sonno profondo...',
    post12Category: 'Salute & Vita',
    post12Date: '20 gennaio 2026',
    post12ReadTime: '7 min di lettura',
    post13Title: 'Effetti del Grounding su Stress e Ansia',
    post13Excerpt: 'Una soluzione naturale allo stress e all\'ansia portati dalla vita moderna: il grounding. Bilanciare il cortisolo con le scarpe earthing nella vita quotidiana e supportare la salute mentale...',
    post13Category: 'Salute & Vita',
    post13Date: '14 marzo 2026',
    post13ReadTime: '6 min di lettura',
    post14Title: 'Storia della Camminata a Piedi Nudi: Confronto con il Mondo Moderno',
    post14Excerpt: 'Da 200.000 anni di evoluzione a piedi nudi alle scarpe a suola spessa di oggi... Come ha vissuto il corpo umano questo cambiamento? Confronto storico tra camminata barefoot e scarpe moderne...',
    post14Category: 'Salute & Vita',
    post14Date: '8 febbraio 2026',
    post14ReadTime: '8 min di lettura',
    post15Title: 'La Scienza del Grounding: Ricerca e Prove',
    post15Excerpt: 'È stato scientificamente dimostrato che il grounding riduce l\'infiammazione, migliora la qualità del sonno e protegge dalle malattie croniche? Ricerca, sicurezza e guida sulla durata...',
    post15Category: 'Salute & Vita',
    post15Date: '1 aprile 2026',
    post15ReadTime: '9 min di lettura',
    post16Title: 'Terapia di Grounding per Emicrania e Mal di Testa',
    post16Excerpt: 'La dimensione neuroinfiammatoria dell\'emicrania e gli effetti del grounding sui meccanismi CGRP, infiammazione e stress. Il grounding come approccio complementare naturale per il mal di testa...',
    post16Category: 'Salute & Vita',
    post16Date: '22 maggio 2026',
    post16ReadTime: '7 min di lettura',
    post17Title: 'Grounding in Città: Tecniche e Superfici',
    post17Excerpt: 'Il grounding è possibile anche vivendo su cemento e asfalto? Superfici conduttive in città, routine nei parchi e tecniche di grounding nel mondo moderno con i modelli conduttivi FentyBarefoot...',
    post17Category: 'Salute & Vita',
    post17Date: '10 giugno 2026',
    post17ReadTime: '6 min di lettura',
    post18Title: 'Moda Sostenibile per una Vita Naturale',
    post18Excerpt: "L'importanza dei vestiti in cotone biologico, lino e materiali riciclabili e i benefici del consumo consapevole.",
    post18Category: 'Sostenibilità',
    post18Date: '15 marzo 2026',
    post18ReadTime: '6 min di lettura',
    post19Title: "Modi per Ridurre la Tua Impronta di Carbonio",
    post19Excerpt: 'Metodi per ridurre le emissioni di carbonio nella vita quotidiana, risparmio energetico e abitudini di consumo consapevole.',
    post19Category: 'Sostenibilità',
    post19Date: '20 marzo 2026',
    post19ReadTime: '5 min di lettura',
    post20Title: 'Supporto a Donne e Bambini Colpiti dalla Guerra',
    post20Excerpt: 'Ogni acquisto crea un impatto. Donare una parte del fatturato rafforza la solidarietà sociale.',
    post20Category: 'Responsabilità Sociale',
    post20Date: '25 marzo 2026',
    post20ReadTime: '5 min di lettura',
    post21Title: 'Un Albero per Tutti: Futuro Verde',
    post21Excerpt: 'Contribuire alla natura con ogni acquisto e l\'importanza dei progetti di rimboschimento.',
    post21Category: 'Ambiente',
    post21Date: '1 aprile 2026',
    post21ReadTime: '4 min di lettura',
    post22Title: 'La Storia dei Prodotti in Cuoio Fatti a Mano',
    post22Excerpt: 'Tecniche di produzione tradizionali, il valore dell\'artigianato e dei materiali di qualità naturale.',
    post22Category: 'Info Prodotto',
    post22Date: '5 aprile 2026',
    post22ReadTime: '7 min di lettura',
    post23Title: 'Benefici per la Salute dei Tessuti Biologici',
    post23Excerpt: 'I tessuti biologici senza prodotti chimici riducono il rischio di allergie con proprietà amiche della pelle.',
    post23Category: 'Salute & Vita',
    post23Date: '10 aprile 2026',
    post23ReadTime: '6 min di lettura',
    post24Title: "Produzione a Carbonio Zero: L'Impegno Ambientale di FentyBarefoot",
    post24Excerpt: 'Processi di produzione a carbonio zero, utilizzo di energia rinnovabile e impatto ambientale misurabile.',
    post24Category: 'Sostenibilità',
    post24Date: '12 aprile 2026',
    post24ReadTime: '5 min di lettura',
    post25Title: 'Futuro Verde: Stiamo Piantando 50.000+ Alberi',
    post25Excerpt: 'Più di 50.000 alberi piantati. Sensibilizzazione ambientale comunitaria e la nostra visione di marchio ecologico.',
    post25Category: 'Ambiente',
    post25Date: '18 aprile 2026',
    post25ReadTime: '4 min di lettura',
    sustainabilityLabel: 'Sostenibilità',
    socialLabel: 'Responsabilità Sociale',
    environmentLabel: 'Ambiente',
    sustainabilitySection: 'Sostenibilità & Vita Naturale',
    newLabel: 'Nuovo',
    allPostsLabel: 'Tutti gli Articoli',
    statFidan: 'Alberi Piantati',
    statCarbon: 'Carbonio Ridotto',
    statPeople: 'Persone Raggiunte',
    statWaste: 'Rifiuti Riciclati',
    impactTitle: 'Futuro Verde: 50.000+ Alberi Piantati',
    impactDesc: 'Un albero per la natura con ogni acquisto. Con i nostri clienti abbiamo piantato più di 50.000 alberi finora.',
  },

  filter: {
    filters: 'Filtri',
    clear: 'Cancella',
    sorting: 'Ordinamento',
    popular: 'Più popolare',
    newest: 'Più recente',
    priceAsc: 'Prezzo: Basso ad Alto',
    priceDesc: 'Prezzo: Alto a Basso',
    discount: 'Sconto più alto',
    topRated: 'Più votati',
    priceRange: 'Fascia di prezzo',
    size: 'Taglia',
    color: 'Colore',
    black: 'Nero',
    white: 'Bianco',
    camel: 'Cammello',
    terracotta: 'Terracotta',
    beige: 'Beige',
    green: 'Verde',
    cream: 'Crema',
    brown: 'Marrone',
    navy: 'Navy',
    olive: 'Verde oliva',
    freeShipping: 'Spedizione gratuita',
    rating: 'Valutazione',
    ratingAll: 'Tutte le valutazioni',
    rating45plus: '4,5+ Stelle',
    rating4plus: '4+ Stelle',
    rating3plus: '3+ Stelle',
    tags: 'Etichette',
    tagBestSeller: 'Più venduto',
    tagNewSeason: 'Nuova stagione',
    tagOrganic: 'Biologico',
    tagVegan: 'Vegano',
    tagPremium: 'Premium',
    tagSpecialPrice: 'Prezzo speciale',
  },

  reviews: {
    title: 'Recensioni clienti',
    reviewsCount: 'recensioni',
    writeReview: 'Scrivi recensione',
    verified: 'Acquisto verificato',
    size: 'Taglia',
    helpful: 'Questa recensione è stata utile?',
    yourRating: 'La tua valutazione',
    veryBad: 'Molto male',
    bad: 'Male',
    average: 'Medio',
    good: 'Buono',
    excellent: 'Eccellente',
    yourName: 'Il tuo nome',
    namePlaceholder: 'Il tuo nome completo',
    purchasedSize: 'Taglia acquistata',
    selectSize: 'Seleziona taglia (opzionale)',
    reviewTitle: 'Titolo recensione',
    titlePlaceholder: 'Riassumi la tua recensione',
    yourReview: 'La tua recensione',
    reviewPlaceholder: 'Condividi la tua esperienza sul prodotto...',
    addPhotos: 'Aggiungi foto',
    maxPhotos: '(Massimo 5 foto)',
    photosSelected: 'foto selezionate. Passa sopra per rimuovere.',
    add: 'Aggiungi',
    cancel: 'Annulla',
    submit: 'Invia recensione',
    submitted: 'Recensione ricevuta!',
    submittedMessage: 'Sarà pubblicata dopo la revisione. Grazie!',
    customerFavorite: 'Preferito dai clienti',
    filterAll: 'Tutto',
    stars: 'Stelle',
    sortNewest: 'Più recente',
    sortHelpful: 'Più utile',
    sortHighest: 'Valutazione più alta',
    sortLowest: 'Valutazione più bassa',
    noReviews: 'Nessuna recensione trovata per questo filtro.',
    showMore: 'Mostra più recensioni',
    moreReviews: 'altre recensioni'
  },

  sizeGuide: {
    title: 'Guida alle taglie',
    subtitle: 'Usa le tue misure per trovare la taglia giusta',
    women: 'Donna',
    men: 'Uomo',
    kids: 'Bambini',
    size: 'Taglia',
    bust: 'Busto',
    waist: 'Vita',
    hip: 'Fianchi',
    height: 'Altezza',
    howToMeasure: 'Come misurare?',
    bustMeasure: 'Misura del busto',
    bustDesc: 'Abbassa le braccia, passa il metro nel punto più largo del tuo petto.',
    waistMeasure: 'Misura della vita',
    waistDesc: "Misura nel punto più stretto della vita dopo aver espirato.",
    hipMeasure: 'Misurare dei fianchi',
    hipDesc: 'Misurare orizzontalmente nel punto più largo dei tuoi fianchi con i piedi uniti.',
    tip: 'Suggerimento',
    tipMessage: 'Se i vostri piedi sono di taglia diversa, prendete come riferimento il più grande.',
    disclaimer: 'Le misure sono approssimative e possono variare in base al prodotto.',
    gotIt: 'Capito',
    womenShoesLabel: 'Scarpe donna estate',
    menShoesLabel: 'Scarpe uomo estate',
    womenClothingLabel: 'Abbigliamento donna estate',
    menClothingLabel: 'Abbigliamento uomo estate',
    euColumn: 'Taglia EU',
    usWomenColumn: 'US Donna',
    usMenColumn: 'US Uomo',
    ukColumn: 'UK',
    footColumn: 'Piede',
    euLabel: 'EU',
    measureShoeTitle: 'Misurare la lunghezza del piede',
    shoeStep1Title: 'Mettersi su carta',
    shoeStep1Desc: 'Posiziona un foglio bianco su una superficie piana e mettiti sopra con i calzini.',
    shoeStep2Title: 'Tracciare il piede',
    shoeStep2Desc: 'Tenete una matita dritta e tracciate intorno al piede dal tallone al dito più lungo.',
    shoeStep3Title: 'Misurare la lunghezza',
    shoeStep3Desc: 'Misurate in cm dal tallone alla punta del dito più lungo.',
    shoeStep4Title: 'Cercare nella tabella',
    shoeStep4Desc: 'Trovate la vostra misura in cm nella colonna "Piede (cm)" sopra.',
    shoeTip: 'Se i vostri piedi sono di taglia diversa, prendete come riferimento il più grande.',
    measureClothingTitle: 'Prendere le misure corporee',
    bustDesc2: 'Misurare orizzontalmente nel punto più largo del petto, sotto le braccia.',
    waistDesc2: 'Misurare nel punto più stretto della vita dopo aver espirato.',
    hipDesc2: 'Misurare orizzontalmente nel punto più largo dei fianchi.',
    heightDesc2: 'Misurare dritto dalla sommità della testa alla pianta dei piedi.',
    clothingTip: 'Prendete le misure con un metro flessibile e assicuratevi che sia ben aderente al corpo.',
    notSureTitle: 'Non siete sicuri?',
    notSureDesc: 'Se siete tra due taglie, scegliete quella più grande. Il nostro negozio offre resi gratuiti.',
    toleranceNote: 'Le misure possono includere una tolleranza di ±1 cm.',
  },

  liveNotif: {
    bought: 'acquistato',
    sandals: 'sandali acquistati',
    slippers: 'pantofole acquistate',
    addedToFavorites: 'aggiunto ai preferiti',
    addedToCart: 'aggiunto al carrello',
    peopleFavorited: 'persone hanno aggiunto ai preferiti',
    inCart: 'nel carrello',
    stockRunning: 'Scorte in esaurimento!',
    lastItems: 'Ultimi',
    itemsLeft: 'articoli rimasti!',
    live: 'Live'
  },

  newsletter: {
    specialOffers: 'Offerte speciali',
    title: 'Iscriviti alla newsletter',
    description: 'Ottieni',
    discount: '10% di sconto',
    descriptionEnd: 'sul tuo primo ordine! Sii il primo a conoscere le nuove collezioni e campagne.',
    emailPlaceholder: 'Il tuo indirizzo email',
    subscribe: 'Iscriviti e risparmia il 10%',
    submitting: 'Invio in corso...',
    sending: 'Invio...',
    unsubscribe: 'Puoi annullare l\'iscrizione in qualsiasi momento.',
    thanks: 'Grazie! 🎉',
    codeSent: 'Il tuo codice sconto del 10% è stato inviato alla tua email.',
    startShopping: 'Inizia a fare acquisti',
    neverShow: 'Non mostrare più',
  },

  wholesale: {
    title: 'Vendita all\'ingrosso',
    subtitle: 'Portale rivenditori & grossisti',
    dealerLogin: 'Accesso rivenditore',
    dealerApply: 'Richiesta rivenditore',
    dealerCode: 'Codice rivenditore / Email',
    dealerCodePlaceholder: 'Il tuo codice rivenditore o email',
    password: 'Password',
    login: 'Accedi',
    notDealer: 'Non sei ancora un rivenditore?',
    apply: 'Candidati',
    fullName: 'Nome completo',
    fullNamePlaceholder: 'Nome completo',
    companyName: 'Nome azienda',
    companyPlaceholder: 'Nome azienda',
    email: 'Email',
    emailPlaceholder: 'azienda@email.com',
    phone: 'Telefono',
    phonePlaceholder: '+39 xxx xxx xxxx',
    city: 'Città',
    cityPlaceholder: 'Roma',
    taxNumber: 'Partita IVA',
    taxPlaceholder: 'La tua partita IVA',
    message: 'Il tuo messaggio',
    messagePlaceholder: 'Presentati brevemente e presenta la tua azienda...',
    submitApplication: 'Invia richiesta',
    submitting: 'Invio in corso...',
    applicationReceived: 'Richiesta ricevuta!',
    contactSoon: 'Ti contatteremo il prima possibile.',
    close: 'Chiudi'
  },

  login: {
    title: 'Accedi',
    email: 'Email',
    emailPlaceholder: 'esempio@email.com',
    password: 'Password',
    passwordPlaceholder: 'Inserisci la tua password',
    rememberMe: 'Ricordami',
    forgotPassword: 'Password dimenticata',
    loginButton: 'Accedi',
    noAccount: 'Non hai un account?',
    signUp: 'Registrati',
    orContinueWith: 'o continua con',
    google: 'Continua con Google',
    welcome: 'Bentornato!',
    subtitle: 'Accedi per continuare lo shopping',
    termsNote: 'Accedendo, accetti i nostri',
    termsLink: 'Termini di servizio',
    termsAnd: 'e',
    privacyLink: 'Informativa sulla privacy',
    termsEnd: '.',
  },

  register: {
    title: 'Registrati',
    name: 'Nome completo',
    namePlaceholder: 'Il tuo nome completo',
    email: 'Email',
    emailPlaceholder: 'esempio@email.com',
    password: 'Password',
    passwordPlaceholder: 'Crea una password forte',
    confirmPassword: 'Conferma password',
    confirmPasswordPlaceholder: 'Reinserisci la tua password',
    terms: 'Accetto i termini e le condizioni',
    registerButton: 'Registrati',
    haveAccount: 'Hai già un account?',
    login: 'Accedi',
    discount: '10% di sconto per i nuovi membri!',
    passwordStrength: { weak: 'Debole', medium: 'Media', strong: 'Forte' },
    sslNote: 'Le tue informazioni sono protette in modo sicuro con SSL',
  },

  speech: {
    welcomeText: `Ciao e benvenuto su FentyBarefoot. Siamo lieti che tu sia entrato nel nostro mondo, dove l'energia dell'estate, la libertà della natura e il vero comfort si incontrano. FentyBarefoot.com è molto più di un semplice marchio. È uno stile di vita che abbraccia la vita naturale, la produzione sostenibile e la libertà di ogni passo.`,
    lang: 'it-IT',
    tooltipText: 'Narrazione avviata con voce femminile!',
    stopTitle: 'Ferma l\'audio',
    listenTitle: 'Ascolta FentyBarefoot 🎙️',
  },

  sustainabilitySpeech: {
    lang: 'it-IT',
    title: 'Sostenibilità & Messa a Terra — Narrazione audio',
    playLabel: 'Ascolta la narrazione audio',
    stopLabel: 'Ferma',
    text: `Benvenuti nel negozio di moda biologica FentyBarefoot. La nostra filosofia di sostenibilità e vita naturale.

Vivere in armonia con la natura non è una scelta — è una responsabilità. Sosteniamo il ritorno all'essenza dell'umanità, al ritmo della natura e ai veri bisogni del corpo, senza farci trascinare dalla velocità del mondo moderno. Ogni prodotto che creiamo è il riflesso di questa filosofia.

L'effetto del contatto con la terra sul corpo umano è noto da secoli. Ecco perché le nostre scarpe di messa a terra non sono solo scarpe — sono un modo per riconnettersi con la natura. Grazie alla speciale struttura della suola conduttiva, aiutano a bilanciare l'energia naturale del corpo, fornendo comfort e consapevolezza durante tutta la giornata.

Le Nostre Scarpe di Messa a Terra. I materiali sono selezionati con cura. Pelle naturale e superfici traspiranti. Struttura della suola conduttiva. Dettagli fatti a mano. Materiali trattati con un minimo di prodotti chimici. Ogni paio è prodotto pensando alla vostra salute e al nostro pianeta.

Tessuti Naturali e Biologici. I prodotti in cotone e lino della nostra collezione sono realizzati con fibre cento per cento naturali. Sono traspiranti e rispettosi della pelle. Non contengono sostanze chimiche sintetiche. Hanno design duraturi e senza tempo.

La Nostra Politica di Sostenibilità. La sostenibilità per noi non è una tendenza — è il fondamento della produzione. Produzione secondo il principio dei rifiuti ridotti. Materie prime rispettose della natura. Produzione artigianale con artigiani locali. Imballaggio minimo e riciclabile. Logistica consapevole e ottimizzata.

Perché Noi? Perché non vendiamo solo prodotti. Offriamo uno stile di vita. Prioritizziamo la naturalezza e la semplicità. Mettiamo la qualità prima del consumo rapido.

Crediamo che sia possibile consumare di meno ma meglio. Vi invitiamo in questo viaggio di ritorno alla natura, per ascoltare il vostro corpo e scoprire il vero comfort.`,
  },

  personalizationPopup: {
    title: 'Personalizzazione & Regalo',
    subtitle: 'Rendi speciale il tuo ordine',
    tabNote: 'Nota ordine',
    tabGift: 'Confezione regalo',
    noteInfoText: 'Puoi scrivere qui un nome personalizzato, un messaggio, una preferenza di colore o qualsiasi richiesta.',
    noteLabel: 'La tua nota personalizzata',
    notePlaceholder: 'Es: Scrivi \'Ti amo\' sopra, avvolgi con nastro rosso...',
    charCount: 'caratteri',
    clearNote: 'Cancella',
    quickTemplates: 'Modelli rapidi',
    templates: ['Scrivi nome', 'Regalo di compleanno', 'Pacco sorpresa', 'Aggiungi messaggio speciale', 'Nessuna fattura'],
    giftWrapTitle: 'Voglio la confezione regalo',
    giftWrapSubtitle: 'Avvolgi con confezione speciale e nastro',
    ribbonColor: 'Colore nastro',
    ribbonColors: { red: 'Rosso', pink: 'Rosa', gold: 'Oro', white: 'Bianco', navy: 'Blu navy', green: 'Verde' },
    greetingCard: 'Aggiungi biglietto di auguri',
    greetingCardSubtitle: 'Biglietto speciale scritto a mano',
    giftMessage: 'Messaggio regalo',
    giftMessageOptional: '(opzionale)',
    giftMessagePlaceholder: 'Es: Buon compleanno! 🎉',
    giftInactiveTitle: 'Attiva l\'opzione confezione regalo',
    giftInactiveSubtitle: 'Fai una sorpresa speciale ai tuoi cari',
    cancel: 'Annulla',
    save: 'Salva',
  },

  checkout: {
    breadcrumbHome: 'Home',
    breadcrumbCheckout: 'Pagamento',
    pageTitle: 'Pagamento Sicuro',
    pageSubtitle: 'Tutte le tue informazioni sono protette con SSL',
    ssl: '256-bit SSL',
    secure3d: '3D Secure',
    pciDss: 'PCI DSS',
    customerTitle: 'Informazioni Cliente',
    guestContinue: 'Continua come ospite',
    memberLogin: 'Accesso membri',
    guestInfo: 'Puoi effettuare un ordine come ospite.',
    register: 'Registrati',
    firstName: 'Nome',
    firstNamePlaceholder: 'Il tuo nome',
    lastName: 'Cognome',
    lastNamePlaceholder: 'Il tuo cognome',
    email: 'Email',
    emailPlaceholder: 'esempio@email.com',
    phone: 'Telefono',
    phonePlaceholder: '+39 5XX XXX XX XX',
    password: 'Password',
    passwordPlaceholder: '••••••••',
    loginButton: 'Accedi',
    noAccount: 'Non hai un account?',
    required: '*',
    addressTitle: 'Indirizzo di consegna',
    address: 'Indirizzo',
    addressPlaceholder: 'Via, numero civico, appartamento...',
    city: 'Città',
    cityPlaceholder: 'Roma',
    postalCode: 'Codice postale',
    postalCodePlaceholder: '00100',
    country: 'Paese',
    orderNote: 'Nota ordine',
    orderNoteOptional: '(Opzionale)',
    orderNotePlaceholder: 'Se hai una nota speciale riguardo al tuo ordine...',
    saveAddressLabel: 'Salva questo indirizzo per il prossimo ordine',
    savedAddressTitle: 'Il tuo indirizzo salvato',
    useSavedAddress: 'Usa indirizzo salvato',

    // Sezione spedizione
    shippingTitle: 'Opzioni di spedizione',
    freeShipping: 'Spedizione gratuita',
    freeShippingDays: '5-7 giorni lavorativi',
    freeShippingBadge: 'Gratuita',
    freeShippingNote: 'Valida per tutti gli ordini.',

    // Sezione pagamento
    paymentTitle: 'Metodo di pagamento',
    creditCard: 'Carta di credito/debito',
    creditCardDesc: 'Visa, Mastercard, Amex',
    paypalDesc: 'Paga con il tuo account PayPal',
    iyzicoDesc: 'Infrastruttura di pagamento turca sicura',
    transfer: 'Bonifico bancario',
    transferDesc: 'Pagamento tramite bonifico bancario',
    cardInfo: 'Dettagli carta',
    cardName: 'Nome sulla carta',
    cardNamePlaceholder: 'NOME COGNOME',
    cardNumber: 'Numero carta',
    cardNumberPlaceholder: '0000 0000 0000 0000',
    cardExpiry: 'Data di scadenza',
    cardExpiryPlaceholder: 'MM/AA',
    cardCvv: 'CVV',
    cardCvvPlaceholder: '•••',
    cardSecureNote: 'I tuoi dati carta vengono trasmessi in modo sicuro con crittografia SSL 256 bit.',

    // Messaggi di errore validazione
    errFirstName: 'Il nome è obbligatorio',
    errLastName: 'Il cognome è obbligatorio',
    errEmail: 'L\'email è obbligatoria',
    errEmailInvalid: 'Inserisci un indirizzo email valido',
    errPhone: 'Il numero di telefono è obbligatorio',
    errAddress: 'L\'indirizzo è obbligatorio',
    errCity: 'La città è obbligatoria',
    errPostalCode: 'Il codice postale è obbligatorio',
    errCardName: 'Il nome sulla carta è obbligatorio',
    errCardNumber: 'Inserisci un numero di carta valido',
    errCardExpiry: 'La data di scadenza è obbligatoria',
    errCardCvv: 'Il CVV è obbligatorio',
    errTerms: 'Devi accettare i termini e le condizioni',
    errCoupon: 'Codice sconto non valido',
    errCouponMinOrder: 'L\'importo minimo per questo coupon è {{amount}}',

    // Carrello / riepilogo
    orderSummaryTitle: 'Riepilogo ordine',
    products: 'articoli',
    emptyCartMsg: 'Il tuo carrello è vuoto',
    discountCode: 'Codice sconto',
    couponPlaceholder: 'INSERISCI CODICE',
    apply: 'Applica',
    applied: 'Applicato',
    couponApplied: 'Codice sconto applicato!',
    couponAutoApplied: 'Codice coupon applicato automaticamente!',
    couponAutoAppliedDesc: 'il codice è stato aggiunto al tuo sconto.',
    subtotal: 'Subtotale',
    shipping: 'Spedizione',
    free: 'Gratuito',
    discount: 'Sconto',
    total: 'Totale',
    vatIncluded: 'IVA inclusa',
    sslSecure: 'SSL Sicuro',
    easyReturn: 'Reso facile',
    qty: 'Qtà',

    // Modulo / invio
    termsText: 'Termini e Condizioni',
    privacyText: 'Informativa sulla Privacy',
    termsAccept: 'letti e accettati.',
    termsAnd: 'e',
    submitting: 'Ordine in elaborazione...',
    submitOrder: 'Completa ordine',
    emptyCart: 'Il tuo carrello è vuoto.',
    startShopping: 'Inizia a fare acquisti',

    // Pagamento express
    expressCheckout: 'Checkout Rapido',
    orPayWith: 'o paga con',
    shopPayDesc: 'Paga in pochi secondi',
    shopPaySubtitle: 'Infrastruttura di pagamento sicura di Shopify',
    shopPayFeature1: 'Checkout in un clic',
    shopPayFeature2: 'Completamente sicuro con crittografia SSL 256 bit',
    shopPayFeature3: 'Pagamento flessibile con Shop Pay Installments',
    shopPayContinue: 'Continua con Shop Pay',
    shopPayRedirect: 'Sarai reindirizzato a Shop Pay alla conferma.',
    googlePayDesc: 'Paga con il tuo account Google',
    googlePayTitle: 'Checkout rapido con Google Pay',
    googlePayNote: 'Paga in pochi secondi con la carta del tuo account Google.',
    googlePayFeature1: 'Collegato al tuo account Google',
    googlePayFeature2: 'Verifica con impronta digitale o riconoscimento facciale',
    googlePayFeature3: 'Infrastruttura globale valida in 130+ paesi',
    googlePayRedirect: 'Il pagamento sarà elaborato tramite l\'infrastruttura sicura di Google.',

    // PayPal
    paypalTitle: 'Pagamento sicuro con PayPal',
    paypalNote: 'Sarai reindirizzato alla pagina PayPal alla conferma.',
    paypalProtection: 'Protezione acquirente PayPal attiva',

    // iyzico
    iyzicoTitle: 'Pagamento sicuro con iyzico',
    iyzicoNote: 'Infrastruttura di pagamento turca affidabile.',
    iyzico3d: '3D Secure',
    iyzicoInstallment: 'Rateizzazione',
    iyzicoPci: 'PCI DSS',

    // Bonifico bancario
    bankAccountTitle: 'Coordinate bancarie',
    accountHolder: 'Intestatario del conto',
    iban: 'IBAN',
    transferNote: 'Non dimenticare di indicare il numero d\'ordine nella causale del bonifico.',

    // Pagina di successo
    successTitle: 'Ordine ricevuto! 🎉',
    successSubtitle: 'Grazie! Il tuo ordine è stato effettuato con successo ed è in preparazione.',
    orderNumberLabel: 'Il tuo numero ordine',
    orderNumberNote: 'Salva questo numero per tracciare il tuo ordine.',
    estimatedDelivery: 'Consegna stimata',
    businessDays: 'Giorni lavorativi',
    paymentLabel: 'Pagamento',
    confirmEmail: 'Email di conferma',
    confirmEmailSent: 'Inviata',
    orderDetails: 'Dettagli ordine',
    deliveryAddress: 'Indirizzo di consegna',
    orderProcess: 'Stato ordine',
    stepReceived: 'Ordine ricevuto',
    stepPreparing: 'In preparazione',
    stepShipped: 'Spedito',
    stepDelivered: 'Consegnato',
    backHome: 'Torna alla home',
    continueShopping: 'Continua gli acquisti',
    contactUs: 'servizio clienti',
    contactNote: 'Per domande, contatta il nostro',
    contactEnd: '.',
    paymentCreditCard: 'Carta di credito',
    paymentTransfer: 'Bonifico bancario',
  },

  cart: {
    title: 'Il mio carrello',
    items: 'articoli',
    empty: 'Il tuo carrello è vuoto',
    emptyDesc: 'Inizia a fare acquisti per scoprire i prodotti',
    startShopping: 'Inizia a fare acquisti',
    color: 'Colore',
    size: 'Taglia',
    shoeSize: 'Numero',
    gift: 'Regalo',
    note: 'Nota',
    subtotal: 'Subtotale',
    shipping: 'Spedizione',
    free: 'Gratuito',
    freeShippingBadge: 'Gratuito',
    total: 'Totale',
    checkout: 'Vai alla cassa',
    continueShopping: 'Continua gli acquisti',
    customsTax: 'Dazio doganale: 0% —',
    noExtraFee: 'Nessun costo extra, tutte le tasse incluse!',
    estimatedDelivery: 'Consegna stimata: 23 marzo (6 giorni lavorativi)',
    returnPolicy: 'Politica di Reso & Cambio',
    returnPolicyTitle: 'Politica di Reso & Cambio',
    returnPolicyClose: 'Chiudi',
    returnPolicy30Days: 'Diritto di reso 30 giorni',
    returnPolicy30DaysDesc: 'Puoi restituire il tuo ordine entro 30 giorni dalla consegna.',
    returnPolicyFreeReturn: 'Reso gratuito',
    returnPolicyFreeReturnDesc: 'Copriamo tutte le spese di restituzione per te.',
    returnPolicyRefundTime: 'Rimborso in 5-7 giorni lavorativi',
    returnPolicyRefundTimeDesc: 'Il tuo pagamento sarà rimborsato entro 5-7 giorni lavorativi.',
    returnPolicyExchange: 'Cambio facile',
    returnPolicyExchangeDesc: 'Cambio gratuito disponibile per modifiche di taglia o colore.',
    returnPolicyNote: 'Resi e cambi validi per prodotti non utilizzati nella confezione originale con etichette attaccate.',
    sole: 'Suola',
    usSize: 'Taglia',
  },

  popularProducts: {
    title: '🏆 Prodotti popolari',
    subtitle: 'Scopri i nostri prodotti più preferiti',
    tabReviews: '🏆 Più recensiti',
    tabFavorites: '❤️ Più preferiti',
    tabSales: '🔥 Più venduti',
    viewProduct: 'Vedi prodotto',
  },

  videos: {
    channelLabel: 'Canale video',
    live: 'IN DIRETTA',
    watchNow: 'Guarda ora',
    subscribe: 'Iscriviti',
    videos: 'Video',
    views: 'Visualizzazioni',
    likes: 'Mi piace',
    subscribers: 'Iscritti',
    awards: 'Premi',
    searchPlaceholder: 'Cerca video...',
    sortNewest: 'Più recenti',
    sortPopular: 'Più popolari',
    sortLiked: 'Più piaciuti',
    featuredVideos: '⭐ Video in evidenza',
    allVideos: 'Tutti i video',
    videosFound: '{{count}} video trovati',
    noVideosFound: 'Nessun video trovato',
    noVideosDesc: 'Nessun video corrisponde ai tuoi criteri di ricerca.',
    newsletterTitle: 'Rimani aggiornato sui nuovi video',
    newsletterDesc: 'Inserisci il tuo indirizzo email per essere informato sui nuovi caricamenti di video.',
    newsletterPlaceholder: 'Il tuo indirizzo email',
    newsletterBtn: 'Iscriviti',
  },

  reviewsPage: {
    title: 'Recensioni Clienti',
    allReviews: 'Tutte le Recensioni Prodotti',
    subtitle: 'Scopri le esperienze di migliaia di clienti soddisfatti',
    avgRating: 'Valutazione Media',
    totalReviews: 'Recensioni',
    verifiedBuyers: 'Verificati',
    photoReviews: 'Con Foto',
    filterTitle: 'Filtra & Ordina',
    clearFilters: 'Cancella Filtri',
    ratingFilter: 'Seleziona Valutazione',
    categoryFilter: 'Seleziona Categoria',
    photosOnly: 'Recensioni con Foto',
    verifiedOnly: 'Acquirenti Verificati',
    sortNewest: 'Più Recenti',
    sortOldest: 'Più Vecchi',
    sortHighest: 'Valutazione Più Alta',
    sortLowest: 'Valutazione Più Bassa',
    sortHelpful: 'Più Utili',
    resultsShowing: 'recensioni visualizzate',
    activeFilters: 'filtri attivi',
    noReviewsFound: 'Nessuna Recensione Trovata',
    noReviewsDesc: 'Nessuna recensione trovata corrispondente ai filtri selezionati.',
    clearFiltersBtn: 'Cancella Filtri',
    viewProduct: 'Visualizza prodotto',
    helpful: 'Utile',
    verified: 'Verificato',
    size: 'Taglia:',
    color: 'Colore:',
    womenClothing: 'Abbigliamento Donna',
    womenShoes: 'Scarpe Donna',
    menClothing: 'Abbigliamento Uomo',
    menShoes: 'Scarpe Uomo',
    copyright: '© 2025 Organic Fashion. Tutti i diritti riservati.',
    productReviewed: 'Prodotto recensito',
    sortLabel: 'Ordina',
    allCategories: 'Tutte le categorie',
    moreFilters: 'Più filtri',
    featured: 'In evidenza',
    reviewsShown: 'recensioni mostrate',
    loadMore: 'Carica altri',
    allLoaded: 'Tutte le recensioni caricate',
  },

  sustainability: {
    heroLabel: 'Moda Biologica · Moda Sostenibile',
    heroTitle: 'Moda in Armonia con la Natura',
    heroSubtitle: 'Aggiungiamo valore al futuro con cotone biologico, materiali riciclati e produzione etica',
    heroExplore: 'Scopri la Collezione',
    heroCerts: 'Le Nostre Certificazioni',
    heroScroll: 'Scorri Verso il Basso',
    statWater: 'Risparmio Idrico',
    statPackaging: 'Imballaggio Riciclato',
    statChemical: 'Riduzione Chimica',
    statHandmade: 'Prodotto Artigianale',
    manifestoLabel: 'Il Nostro Manifesto',
    manifestoTitle: 'La Nostra Filosofia di Moda Sostenibile',
    carbonNeutral: 'Neutro al Carbonio',
    materialsLabel: 'I Nostri Materiali',
    materialsTitle: 'Materiali Naturali e Riciclati',
    materialsSubtitle: 'Utilizziamo materiali ecologici in ogni prodotto',
    certsLabel: 'Certificazioni & Standard',
    certsTitle: 'Le Nostre Approvazioni Internazionali',
    certsSubtitle: 'Certificazioni che dimostrano il nostro impegno per la sostenibilità',
    timelineLabel: 'Il Nostro Viaggio di Sostenibilità',
    timelineTitle: 'Meglio Ogni Anno',
    faqLabel: 'Domande Frequenti',
    faqTitle: 'Cosa Ti Chiedi',
    ctaLabel: 'Unisciti alla Moda Sostenibile',
    ctaTitle: 'Unisciti alla Moda Sostenibile',
    ctaSubtitle: 'Scopri la nostra collezione di produzione biologica ed etica',
    ctaExplore: 'Esplora la Collezione',
    ctaBlog: 'I Nostri Post del Blog',
    footerDesc: 'Produciamo moda sostenibile ed etica in armonia con la natura.',
    footerMaterials: 'Materiali',
    footerCerts: 'Certificazioni',
    footerCollections: 'Collezioni',
    audioStarted: 'Iniziato con voce femminile!',
    audioPlaying: 'IN RIPRODUZIONE',
    audioLanguages: 'Lingue Disponibili',
  },

  liveChat: {
    title: 'Supporto FentyBarefoot',
    online: 'Online · Risposta rapida',
    hello: 'Ciao!',
    introDesc: 'Siamo felici di aiutarti. Inserisci il tuo nome per iniziare.',
    namePlaceholder: 'Il tuo nome (opzionale)',
    startChat: 'Avvia chat',
    continueAsGuest: 'Continua come ospite',
    welcomeMsg: 'Come possiamo aiutarti? 😊',
    supportTeam: 'Team di supporto',
    messagePlaceholder: 'Scrivi il tuo messaggio...',
    secureNote: 'Connessione sicura · La tua privacy è protetta',
    voiceCall: 'Chiamata vocale',
    typing: 'Sta scrivendo...',
    callTitle: 'Linea di supporto',
    callMinimize: 'Minimizza',
    callClose: 'Chiudi',
    callConnecting: 'Connessione in corso...',
    callConnected: 'Connesso',
    callBusy: 'Attualmente occupato',
    callEnded: 'Chiamata terminata',
    callWaiting: 'In attesa dell\'operatore...',
    callBusyNote: 'Riprova più tardi',
    callLive: 'Connessione in diretta',
    callHangupNote: 'Premi il pulsante rosso per terminare la chiamata',
    callMinBar: 'Linea di supporto',
    callExpand: 'Espandi',
  },

  sizeGuideAudio: {
    lang: 'it-IT',
    listenBtn: 'Ascolta la guida audio',
    stopBtn: 'Ferma',
    desc: 'Ascolta la nostra guida alle taglie',
    playingDesc: 'Narrazione audio in corso...',
    narration: 'Le scarpe barefoot sono progettate per riportarti all\'essenza della natura. Invece delle suole isolate della vita moderna, senti la potenza del contatto naturale. Le dita si allargano liberamente, la fascia plantare utilizza la sua potenza di molla naturale, i nervi propriocettivi vengono attivati. Il grounding aggiunge un\'altra dimensione a questo. Al cuore di questo design speciale c\'è il rame. Il rame è uno dei metalli conduttori più potenti in natura. Grazie alla sua capacità di trasportare cariche elettriche... trasferisce l\'elettricità statica accumulata nel vostro corpo alla terra e vi permette di entrare in contatto con gli elettroni negativi naturali della terra. Cosa succede in questo processo? Il vostro corpo... comincia a tornare al suo equilibrio naturale. Con l\'effetto grounding, lo stress e la tensione possono diminuire, la qualità del sonno può migliorare, il rilassamento muscolare e articolare può essere raggiunto, la circolazione sanguigna può essere supportata, e un notevole aumento dei livelli di energia può essere percepito. Il design barefoot non si limita all\'energia. La larga scatola per le dita consente alle vostre dita di allargarsi naturalmente. La suola sottile e flessibile vi permette di sentire il terreno. Il vostro piede... si muove come dovrebbe. Perché il piede umano non è stato creato per essere supportato... ma per funzionare naturalmente. I punti in rame conduttore sulle suole delle scarpe da grounding entrano in contatto con la terra ad ogni passo, stabilendo una connessione ininterrotta tra il vostro corpo e il mondo. Questo non è solo una scarpa... questo è un modo per tornare alla natura. Ad ogni passo... sentite l\'energia della terra. Sentite l\'equilibrio. Sentite la natura. Riconnettetevi con le scarpe barefoot da grounding. Scoprite il potere guaritore del grounding e della camminata a piedi nudi. Collegandosi al flusso costante di elettroni benefici dalla superficie terrestre, questa connessione supporta i processi naturali di guarigione e rigenerazione del corpo, promuovendo una salute e un benessere ottimali nella vita quotidiana.',
  },
  marquee: {
    discount: '70% SCONTO',
    combos: 'SUI COMBO',
    summer: 'SPECIALE ESTATE',
  },

  // New page sections
  aboutUs: {
    pageTitle: 'Chi Siamo — FentyBarefoot',
    heroTitle: 'Moda Unita alla Natura',
    heroSubtitle: 'Libertà in ogni passo, sostenibilità in ogni prodotto',
    storyLabel: 'La Nostra Storia',
    storyTitle: 'Come è Nato FentyBarefoot',
    storyP1: 'Partendo come un piccolo laboratorio di scarpe barefoot a Istanbul nel 2018, FentyBarefoot è diventato oggi uno dei principali marchi di moda sostenibile in Europa.',
    storyP2: 'La nostra fondatrice Leyla Fenton non ha mai dimenticato la sensazione di libertà quando i suoi piedi toccavano la terra crescendo nelle fattorie biologiche.',
    storyP3: 'Oggi spediamo in oltre 50 paesi. Tutti i nostri prodotti sono fatti a mano, utilizzando materiali biologici.',
    missionLabel: 'Missione & Visione',
    missionTitle: 'Perché FentyBarefoot?',
    missionText: 'Il nostro obiettivo non è solo vendere bei prodotti, ma offrire uno stile di vita più sano, più libero e più armonioso con la natura.',
    visionLabel: 'La Nostra Visione',
    visionText: 'Raggiungere il nostro obiettivo di produzione 100% carbon neutral entro il 2030.',
    missionLabel2: 'La Nostra Missione',
    missionDesc: 'Essere un marchio di moda progettato pensando alla salute dei piedi, prodotto con materiali naturali.',
    valuesLabel: 'I Nostri Valori',
    valuesTitle: '4 Valori Fondamentali che Ci Definiscono',
    value1Title: 'Naturalità',
    value1Text: 'Utilizziamo materiali organici e naturali in tutti i nostri prodotti.',
    value2Title: 'Sostenibilità',
    value2Text: 'Processi di produzione e imballaggi eco-compatibili.',
    value3Title: 'Trasparenza',
    value3Text: 'Manteniamo aperto il nostro processo produttivo, i materiali e i prezzi.',
    value4Title: 'Qualità',
    value4Text: 'Ogni prodotto è realizzato con cura per un uso duraturo.',
    numbersLabel: 'I Nostri Numeri',
    numbersTitle: 'Prova di Fiducia',
    stat1Value: '200.000+',
    stat1Label: 'Clienti Felici',
    stat2Value: '50+',
    stat2Label: 'Paesi',
    stat3Value: '500+',
    stat3Label: 'Prodotti Artigianali',
    stat4Value: '6+',
    stat4Label: 'Anni di Esperienza',
    teamLabel: 'Il Nostro Team',
    teamTitle: 'Un Team che Lavora con Passione',
    teamSubtitle: 'Il nostro team di esperti dal design alla produzione, dalla logistica al servizio clienti.',
    certLabel: 'Certificazioni',
    certTitle: 'La Nostra Credibilità è Documentata',
    ctaTitle: 'Un Futuro Migliore Insieme',
    ctaText: 'Incontra la famiglia FentyBarefoot e fai parte della moda sostenibile.',
    ctaExplore: 'Esplora la Collezione',
    ctaBlog: 'I Nostri Post del Blog',
    breadcrumb: 'Chi Siamo',
    noWarBadge: 'Una Posizione per la Pace',
    noWarTitle: 'No alla Guerra, Sì alla Vita',
    noWarSubtitle: "Non sosteniamo nessuna morte umana. Ci opponiamo alle armi chimiche e a ogni azione che disturba l'equilibrio della natura.",
    noWarP1: "La vera sostenibilità richiede di opporsi a ogni danno che gli esseri umani si infliggono a vicenda e alla natura. Ecco perché dichiariamo apertamente la nostra opposizione alla guerra, alla violenza e alle armi chimiche.",
    noWarP2: "Le armi chimiche inquinano il suolo, l'acqua e l'aria. Opporsi a questi strumenti che perturbano l'atmosfera e privano gli esseri viventi del loro diritto alla vita è parte inseparabile del nostro rispetto per il nostro pianeta.",
    noWarP3: "Da FentyBarefoot, portiamo questa convinzione in ogni prodotto e lavoriamo per lasciare un mondo pacifico e verde alle generazioni future.",
    noWarStat1: 'Contro la guerra',
    noWarStat2: 'Contro le armi chimiche',
    noWarStat3: 'Difensore della natura',
    noWarStat4: 'Difensore della vita',
    noWarQuote: "Non c'è sostenibilità senza pace. Opporsi a tutto ciò che nuoce all'umanità e alla natura è sia una responsabilità etica che ecologica.",
  },

  termsConditions: {
    pageTitle: 'Termini & Condizioni — FentyBarefoot',
    title: 'Termini e Condizioni',
    subtitle: 'Ultimo aggiornamento: Gennaio 2026',
    intro: 'Utilizzando il sito web FentyBarefoot, accetti i seguenti termini e condizioni. Si prega di leggerli attentamente.',
    sec1Title: '1. Disposizioni Generali',
    sec1Text: 'Questo sito web è gestito da FentyBarefoot. L\'accesso e l\'utilizzo del sito significano l\'accettazione di questi termini.',
    sec2Title: '2. Account & Iscrizione',
    sec2Text: 'Quando crei un account, devi fornire informazioni accurate e complete. Sei responsabile della sicurezza del tuo account.',
    sec3Title: '3. Acquisti & Pagamenti',
    sec3Text: 'Tutti i prezzi sono indicati IVA inclusa nella valuta specificata. La conferma dell\'ordine significa che è stato stabilito un contratto di vendita.',
    sec4Title: '4. Consegna',
    sec4Text: 'I tempi di consegna coprono i giorni lavorativi specificati dalla conferma dell\'ordine. Non siamo responsabili per ritardi dovuti a informazioni di indirizzo errate.',
    sec5Title: '5. Annullamento & Resi',
    sec5Text: 'Puoi restituire il tuo ordine entro 30 giorni dal ricevimento. Gli ordini già preparati non possono essere annullati.',
    sec6Title: '6. Proprietà Intellettuale',
    sec6Text: 'Tutti i contenuti del sito web sono di proprietà di FentyBarefoot. La copia non autorizzata e l\'uso commerciale sono vietati.',
    sec7Title: '7. Limitazione di Responsabilità',
    sec7Text: 'FentyBarefoot non può essere ritenuto responsabile per danni deriventi da errori utente o casi di forza maggiore.',
    sec8Title: '8. Legge Applicabile',
    sec8Text: 'Questi termini sono soggetti alle leggi della Repubblica di Turchia. I tribunali di Istanbul hanno giurisdizione nelle controversie.',
    contactTitle: 'Contatti',
    contactText: 'Per le richieste sulla privacy: privacy@fentybarefoot.com',
    breadcrumb: 'Privacy & Cookie',
  },

  privacyPolicy: {
    pageTitle: 'Privacy & Cookie — FentyBarefoot',
    title: 'Informativa sulla Privacy & Cookie',
    subtitle: 'Ultimo aggiornamento: Gennaio 2026',
    intro: 'Da FentyBarefoot, attribuiamo grande importanza alla privacy dei tuoi dati personali.',
    dataTitle: 'Dati Personali Raccolti',
    data1: 'Dati di identità: Nome e cognome',
    data2: 'Dati di contatto: Email, numero di telefono',
    data3: 'Dati di indirizzo: Indirizzo di consegna e fatturazione',
    data4: 'Dati di pagamento: Ultime 4 cifre della carta',
    data5: 'Dati di utilizzo: Statistiche di navigazione (anonimi)',
    usageTitle: 'Finalità dell\'Utilizzo dei Dati',
    usage1: 'Elaborazione ordini e consegna',
    usage2: 'Servizio clienti e supporto',
    usage3: 'Adempimento degli obblighi legali',
    usage4: 'Comunicazioni di marketing (con il tuo consenso)',
    usage5: 'Sicurezza del sito e miglioramento del servizio',
    cookieTitle: 'Politica sui Cookie',
    cookieIntro: 'Sul nostro sito vengono utilizzati tre tipi di cookie:',
    cookie1Title: 'Cookie Necessari',
    cookie1Text: 'Necessari per il corretto funzionamento del sito. Non possono essere disattivati.',
    cookie2Title: 'Cookie di Performance',
    cookie2Text: 'Analizza l\'utilizzo del sito con Google Analytics.',
    cookie3Title: 'Cookie di Marketing',
    cookie3Text: 'Utilizzati per la pubblicità personalizzata. Attivati con il tuo consenso.',
    sharingTitle: 'Condivisione dei Dati',
    sharingText: 'I tuoi dati non vengono condivisi con terze parti, eccetto le società di consegna, i fornitori di servizi di pagamento e in caso di obblighi legali.',
    rightsTitle: 'I Tuoi Diritti',
    rights1: 'Diritto di sapere se i tuoi dati personali vengono elaborati',
    rights2: 'Diritto di accesso ai tuoi dati elaborati',
    rights3: 'Diritto di rettifica dei dati errati',
    rights4: 'Diritto alla cancellazione (diritto all\'oblio)',
    rights5: 'Diritto di opposizione al trattamento dei dati',
    securityTitle: 'Misure di Sicurezza',
    securityText: 'Proteggiamo i tuoi dati con crittografia SSL a 256 bit, server sicuri e audit di sicurezza regolari.',
    contactTitle: 'Contatti',
    contactText: 'Per le richieste sulla privacy: privacy@fentybarefoot.com',
    breadcrumb: 'Privacy & Cookie',
  },

  returnsExchanges: {
    pageTitle: 'Resi & Cambi — FentyBarefoot',
    title: 'Resi & Cambi',
    subtitle: 'Garanzia di reso facile, veloce e gratuita',
    hero1Value: '30 Giorni',
    hero1Label: 'Periodo di reso',
    hero2Value: 'Gratuito',
    hero2Label: 'Spedizione reso',
    hero3Value: '7-12 Giorni',
    hero3Label: 'Tempo rimborso',
    hero4Value: 'Illimitato',
    hero4Label: 'Diritti di cambio',
    processTitle: 'Processo di Reso — 4 Semplici Passi',
    step1Title: 'Richiedere il Reso',
    step1Text: 'Scrivi a support@fentybarefoot.com con il numero dell\'ordine o usa la chat dal vivo.',
    step2Title: 'Ottenere l\'Approvazione',
    step2Text: 'Entro 24 ore, ti verrà inviato via email una conferma di reso e un codice di spedizione gratuito.',
    step3Title: 'Spedire il Prodotto',
    step3Text: 'Invia semplicemente il prodotto nella sua confezione originale con il codice di spedizione fornito.',
    step4Title: 'Ricevere il Rimborso',
    step4Text: 'Il tuo pagamento viene rimborsato entro 5-7 giorni lavorativi dall\'arrivo del prodotto.',
    condTitle: 'Condizioni di Reso',
    cond1: 'La richiesta di reso deve essere creata entro 30 giorni dalla consegna',
    cond2: 'Il prodotto deve essere non utilizzato e nella confezione originale',
    cond3: 'Tutte le etichette devono essere intatte',
    cond4: 'I prodotti scontati sono soggetti alle stesse condizioni di reso',
    cond5: 'I prodotti personalizzati non possono essere restituiti',
    exchTitle: 'Politica di Cambio',
    exchText: 'Hai il diritto a un cambio gratuito per modifiche di taglia o colore entro 30 giorni dalla consegna.',
    faqTitle: 'Domande Frequenti',
    faq1Q: 'Quando riceverò il mio rimborso?',
    faq1A: 'Il tuo rimborso viene elaborato sul metodo di pagamento originale entro 5-7 giorni lavorativi.',
    faq2Q: 'Posso restituire ordini internazionali?',
    faq2A: 'Sì! Hai anche un diritto di reso di 30 giorni per gli ordini internazionali. Copriamo le spese di spedizione.',
    faq3Q: 'Quando verrà preparato il mio ordine?',
    faq3A: 'Gli ordini vengono generalmente preparati e spediti entro 1-2 giorni lavorativi.',
    faq4Q: 'Posso cambiare l\'indirizzo di consegna?',
    faq4A: 'Puoi cambiare l\'indirizzo prima della spedizione dell\'ordine.',
    contactTitle: 'Hai ancora domande?',
    contactText: 'Puoi contattare il nostro servizio clienti 24/7.',
    contactBtn: 'Supporto Live',
    breadcrumb: 'Resi & Cambi',
  },

  deliveryShipping: {
    pageTitle: 'Consegna & Spedizione — FentyBarefoot',
    title: 'Consegna & Spedizione',
    subtitle: 'Veloce, sicura e spesso gratuita',
    hero1Value: 'Gratuito',
    hero1Label: 'Spedizione Standard',
    hero2Value: '3-5 Giorni',
    hero2Label: 'Nazionale',
    hero3Value: '7-12 Giorni',
    hero3Label: 'Internazionale',
    hero4Value: '50+',
    hero4Label: 'Paesi di consegna',
    domesticTitle: 'Consegna Nazionale (Turchia)',
    domesticIntro: 'Spedizione gratuita per tutti gli ordini in Turchia. Gli ordini vengono preparati e spediti entro 1-2 giorni lavorativi.',
    domestic1Title: 'Spedizione Standard',
    domestic1Time: '3-5 giorni lavorativi',
    domestic1Price: 'Gratuito',
    domestic2Title: 'Spedizione Express',
    domestic2Time: '1-2 giorni lavorativi',
    domestic2Price: '₺29,90',
    domestic3Title: 'Consegna il Giorno Stesso',
    domestic3Time: 'Area Istanbul',
    domestic3Price: '₺49,90 (ordini >₺150)',
    intlTitle: 'Consegna Internazionale',
    intlIntro: 'Spediamo in oltre 50 paesi.',
    intl1Region: 'Europa',
    intl1Time: '7-12 giorni lavorativi',
    intl1Price: 'Gratuito (150€+) / 12€',
    intl2Region: 'USA & Canada',
    intl2Time: '10-15 giorni lavorativi',
    intl2Price: 'Gratuito (200$+) / 18$',
    intl3Region: 'Medio Oriente',
    intl3Time: '8-14 giorni lavorativi',
    intl3Price: '15$',
    intl4Region: 'Altri Paesi',
    intl4Time: '12-20 giorni lavorativi',
    intl4Price: 'Contattaci',
    trackTitle: 'Tracciamento Ordine',
    trackText: 'Quando il tuo ordine viene spedito, il numero di tracciamento ti viene inviato via email.',
    customsTitle: 'Dogana & Tasse',
    customsText: 'Nessuna dogana o tassa aggiuntiva si applica per gli ordini turchi. L\'IVA è inclusa per gli ordini europei.',
    faqTitle: 'Domande Frequenti',
    faq1Q: 'Quando arriverà il mio ordine?',
    faq1A: 'Consegnato in 3-5 giorni in Turchia e in 7-12 giorni lavorativi in Europa.',
    faq2Q: 'La spedizione è gratuita?',
    faq2A: 'Gratuito per tutti gli ordini in Turchia! Gratuito per ordini >150€ in Europa e >200$ negli USA.',
    faq3Q: 'Quando verrà preparato il mio ordine?',
    faq3A: 'Gli ordini vengono generalmente preparati e spediti entro 1-2 giorni lavorativi.',
    faq4Q: 'Posso cambiare l\'indirizzo di consegna?',
    faq4A: 'Prima della spedizione, sì.',
    contactTitle: 'Hai una domanda?',
    contactText: 'Puoi contattare la nostra linea di supporto 24/7.',
    contactBtn: 'Ottieni Supporto',
    breadcrumb: 'Spedizione & Consegna',
  },

  returnPolicyPopup: {
    title: 'Politica di Reso & Cambio', subtitle: 'Resi gratuiti entro 30 giorni', close: 'Chiudi',
    point1Title: 'Reso 30 Giorni', point1Desc: 'Puoi restituire il tuo ordine entro 30 giorni dalla ricezione.',
    point2Title: 'Reso Gratuito', point2Desc: 'Copriamo tutte le spese di spedizione per i resi.',
    point3Title: 'Rimborso 5-7 Giorni', point3Desc: 'Il rimborso viene elaborato entro 5-7 giorni lavorativi.',
    point4Title: 'Cambio Facile', point4Desc: 'Cambio gratuito disponibile per modifiche di taglia o colore.',
    point5Title: 'Confezione Originale', point5Desc: 'Il prodotto deve essere non utilizzato e nella confezione originale.',
    ctaBtn: 'Politica Completa', detailsLink: '/returns-exchanges',
  },

  faqPage: {
    title: 'Domande Frequenti', subtitle: 'Trova risposte a tutto ciò che ti chiede', breadcrumb: 'FAQ',
    searchPlaceholder: 'Cerca domande...', allCategories: 'Tutto', catOrders: 'Ordini', catShipping: 'Spedizione', catReturns: 'Resi', catProducts: 'Prodotti', catPayments: 'Pagamento',
    noResults: 'Nessun risultato', noResultsDesc: 'Prova un termine diverso.',
    contactTitle: 'Ancora domande?', contactText: 'Il nostro servizio clienti è disponibile 24/7.', contactBtn: 'Supporto Live',
  },

  returnsPage: {
    title: 'Politica di Reso', subtitle: 'Resi gratuiti entro 30 giorni', breadcrumb: 'Politica di Reso',
    heroStat1Value: '30', heroStat1Label: 'Giorni di Reso', heroStat2Value: 'Gratuito', heroStat2Label: 'Reso', heroStat3Value: '5-7', heroStat3Label: 'Giorni Rimborso',
    processTitle: 'Processo di Reso',
    step1Num: '01', step1Title: 'Crea Richiesta', step1Desc: 'Crea una richiesta via email o chat.',
    step2Num: '02', step2Title: 'Approvazione & Codice', step2Desc: 'Entro 24h ricevi il codice di spedizione gratuito.',
    step3Num: '03', step3Title: 'Imballare', step3Desc: 'Imballare nella confezione originale.',
    step4Num: '04', step4Title: 'Consegna a UPS', step4Desc: 'Porta al punto UPS più vicino.',
    step5Num: '05', step5Title: 'Ricevi il Rimborso', step5Desc: 'Rimborso entro 5-7 giorni lavorativi.',
    eligibleTitle: 'Idoneo al Reso', elig1: 'Prodotti non usati nella confezione originale', elig2: 'Prodotti con etichette intatte', elig3: 'Richieste entro 30 giorni', elig4: 'Prodotti scontati (stesse condizioni)',
    notEligibleTitle: 'Non Idoneo', notElig1: 'Prodotti personalizzati', notElig2: 'Prodotti usati', notElig3: 'Richieste dopo 30 giorni', notElig4: 'Confezioni danneggiate',
    ctaTitle: 'Vuoi avviare un reso?', ctaText: 'Il nostro team è felice di aiutarti.', ctaBtn: 'Crea Richiesta',
  },

  shippingPage: {
    title: 'Spedizione & Consegna', subtitle: 'Consegna sicura e tracciabile con UPS', breadcrumb: 'Spedizione & Consegna',
    upsBadge: 'Partner Ufficiale UPS', upsDesc: 'Consegniamo tutti gli ordini in sicurezza tramite UPS.',
    avgDelivery: '6 Giorni Lavorativi', avgDeliveryLabel: 'Media Internazionale',
    trackingTitle: 'Tracciamento in Tempo Reale', trackingDesc: 'Numero di tracciamento UPS per ogni ordine.',
    domesticTitle: 'Consegna Nazionale (Turchia)', domesticDesc: 'Spedizione gratuita su tutti gli ordini in Turchia.',
    dom1Title: 'Standard UPS', dom1Time: '3-5 Giorni Lavorativi', dom1Price: 'Gratuito',
    dom2Title: 'UPS Express', dom2Time: '1-2 Giorni Lavorativi', dom2Price: '₺29,90',
    dom3Title: 'Stesso Giorno (Istanbul)', dom3Time: 'Giorno ordine', dom3Price: '₺49,90',
    intlTitle: 'Consegna Internazionale', intlDesc: 'Consegna in oltre 50 paesi via UPS.',
    zoneEurope: 'Europa', zoneEuropeTime: '6-10 Giorni Lavorativi', zoneEuropePrice: 'Gratuito (150€+) / 12€',
    zoneUSA: 'USA & Canada', zoneUSATime: '6-10 Giorni Lavorativi', zoneUSAPrice: 'Gratuito ($200+) / $18',
    zoneMiddleEast: 'Medio Oriente', zoneMiddleEastTime: '8-12 Giorni Lavorativi', zoneMiddleEastPrice: '$15',
    zoneOther: 'Altri Paesi', zoneOtherTime: '10-15 Giorni Lavorativi', zoneOtherPrice: 'Contattaci',
    packagingTitle: 'Imballaggio Eco-Friendly', packagingDesc: 'Tutti gli ordini in materiali 100% riciclati.',
    faqTitle: 'FAQ Spedizione',
    faq1Q: 'Quando sarà spedito il mio ordine?', faq1A: 'Entro 1-2 giorni lavorativi.',
    faq2Q: 'Come uso il numero di tracciamento UPS?', faq2A: 'Inserisci su ups.com o usa l\'app UPS.',
    faq3Q: 'Posso cambiare l\'indirizzo?', faq3A: 'Prima della spedizione, sì.',
    faq4Q: 'Cosa succede se la consegna fallisce?', faq4A: 'UPS tenta 3 volte, poi lascia il pacco al punto UPS.',
    ctaTitle: 'Domande sulla Spedizione?', ctaText: 'Supporto 24/7 disponibile.', ctaBtn: 'Supporto Live',
  },

  favorites: {
    title: 'I Miei Preferiti',
    itemsCount: 'prodotti aggiunti ai preferiti',
    emptyTitle: 'La tua lista dei preferiti è vuota',
    emptySubtitle: 'Nessun prodotto preferito aggiunto ancora',
    emptyDesc: 'Clicca sull\'icona cuore dei prodotti che ti piacciono per aggiungerli ai preferiti. Non è necessario un account!',
    startShopping: 'Inizia a fare acquisti',
    clearAll: 'Cancella tutto',
    remove: 'Rimuovi dai preferiti',
    viewProduct: 'Vedi prodotto',
    suggestionsTitle: 'Esplora le nostre collezioni',
    clearConfirmTitle: 'Cancellare tutti i preferiti?',
    clearConfirmDesc: 'Questa azione non può essere annullata. Tutti i tuoi prodotti preferiti verranno eliminati.',
    clearConfirmBtn: 'Sì, cancella',
    cancel: 'Annulla',
    addedToFavorites: 'Aggiunto ai preferiti!',
    removedFromFavorites: 'Rimosso dai preferiti',
  },
  returnPolicyAudio: {
    lang: 'it-IT',
    listenBtn: 'Ascolta la guida audio',
    stopBtn: 'Ferma',
    desc: 'Ascolta la nostra politica di reso e cambio',
    playingDesc: 'Narrazione audio in corso...',
    narration: "Ciao! Vorrei parlarvi della politica di reso e cambio di FentyBarefoot. Potete restituire i vostri prodotti entro trenta giorni dalla ricezione, completamente gratuitamente. Copriamo tutte le spese di spedizione del reso. Una volta ricevuto il prodotto restituito, il vostro pagamento sarà rimborsato integralmente al metodo di pagamento originale entro cinque-sette giorni lavorativi. Per un reso o un cambio, il prodotto deve essere non utilizzato, con tutte le etichette intatte e nella sua confezione originale. Per qualsiasi domanda, il nostro supporto live disponibile ventiquattr'ore su ventiquattro è sempre a vostra disposizione. Grazie!",
  },
  ugcGallery: {
    badge: 'Foto Clienti',
    title: 'Da Voi',
    subtitle: 'FentyBarefoot attraverso gli occhi dei nostri clienti da tutto il mondo — persone reali, momenti reali.',
    shareText: 'Condividi anche tu la tua esperienza FentyBarefoot!',
    shareBtn: 'Condividi con #FentyBarefoot',
    prevBtn: 'Precedente',
    nextBtn: 'Successivo',
  },
  podiatristSection: {
    title: 'Opinioni di Esperti Podologi',
    subtitle: 'Podologi di fama internazionale condividono le loro osservazioni scientifiche e cliniche sulla tecnologia di grounding FentyBarefoot.',
    listenBtn: 'Ascolta',
    stopBtn: 'Ferma',
    statDoctors: 'Medici Esperti',
    statStudies: 'Studi Clinici',
    statPatients: 'Osservazioni Pazienti',
    disclaimer: 'Le opinioni degli esperti si basano su esperienze cliniche personali. I risultati individuali possono variare.',

    doctor1Name: 'Dr. Mehmet Yılmaz',
    doctor1Title: 'Specialista in Podiatria | Facoltà di Medicina di Istanbul',
    doctor1Quote: 'Il grounding non è solo un passo — è una vera connessione che stabilisci con la natura. Ogni volta che un paziente lo sperimenta, posso sentire la trasformazione.',
    doctor1Narration: 'Le scarpe di grounding Barefoot sono progettate per riportarti all\'essenza della natura. Invece delle suole isolate della vita moderna, senti la potenza del contatto naturale. Grazie ai dettagli conduttori in rame, l\'energia della terra raggiunge direttamente il tuo corpo. Questo effetto crea miglioramenti misurabili anche nei pazienti con dolore cronico. Nelle mie osservazioni cliniche, gli utenti barefoot hanno riportato il trenta percento in meno di dolore ai piedi rispetto agli utenti di scarpe convenzionali. I punteggi di postura ed equilibrio sono migliorati significativamente. I vostri piedi sono le fondamenta del vostro corpo. Dategli la libertà che meritano.',

    doctor2Name: 'Dr. Sarah Johnson',
    doctor2Title: 'Specialista Piede & Caviglia | London Foot Clinic',
    doctor2Quote: 'I vostri piedi sono gli organi più trascurati del vostro corpo. La filosofia barefoot restituisce loro la libertà che meritano.',
    doctor2Narration: 'La biomeccanica del piede è l\'area più trascurata dall\'industria moderna delle scarpe. Le scarpe convenzionali rendono passivi le ventisei ossa, trentatatre articolazioni e oltre cento muscoli del piede. Questo porta a debolezza muscolare e deterioramento dell\'equilibrio. Il design barefoot racconta una storia diversa. Le dita si allargano liberamente. La fascia plantare utilizza la sua potenza di molla naturale. I nervi propriocettivi vengono attivati. Il grounding aggiunge un\'altra dimensione a questo. Al cuore di questo design speciale c\'è il rame. Il rame è uno dei metalli conduttori più potenti in natura. Grazie alla sua capacità di trasportare cariche elettriche... trasferisce l\'elettricità statica accumulata nel vostro corpo alla terra e vi permette di entrare in contatto con gli elettroni negativi naturali della terra. Cosa succede in questo processo? Il vostro corpo... comincia a tornare al suo equilibrio naturale. Con l\'effetto grounding, lo stress e la tensione possono diminuire, la qualità del sonno può migliorare, il rilassamento muscolare e articolare può essere raggiunto, la circolazione sanguigna può essere supportata, e un notevole aumento dei livelli di energia può essere percepito. Il design barefoot non si limita all\'energia. La larga scatola per le dita consente alle vostre dita di allargarsi naturalmente. La suola sottile e flessibile vi permette di sentire il terreno. Il vostro piede... si muove come dovrebbe. Perché il piede umano non è stato creato per essere supportato... ma per funzionare naturalmente. I punti in rame conduttore sulle suole delle scarpe da grounding entrano in contatto con la terra ad ogni passo, stabilendo una connessione ininterrotta tra il vostro corpo e il mondo. Questo non è solo una scarpa... questo è un modo per tornare alla natura. Ad ogni passo... sentite l\'energia della terra. Sentite l\'equilibrio. Sentite la natura. Riconnettetevi con le scarpe barefoot da grounding. Scoprite il potere guaritore del grounding e della camminata a piedi nudi. Collegandosi al flusso costante di elettroni benefici dalla superficie terrestre, questa connessione supporta i processi naturali di guarigione e rigenerazione del corpo, promuovendo una salute e un benessere ottimali nella vita quotidiana.',
  },
  groundingAudio: {
    badge: 'Filosofia del Grounding',
    title: 'Sentite l\'Energia della Terra',
    subtitle: 'Vivete la scienza dietro le scarpe di grounding barefoot e il potere curativo della natura attraverso l\'audio.',
    listenBtn: 'Ascolta Ora',
    stopBtn: 'Ferma',
    bannerDesc: 'Ascolta le istruzioni per le misure',
    playingLabel: 'Guida audio in riproduzione...',
    stopDesc: 'Clicca per fermare',
    shoeNarration: 'Si prega di misurare il piede nudo in centimetri, sia in lunghezza che in larghezza.',
    clothingNarration: 'Misura petto, vita, fianchi e altezza in centimetri.',
  },
  wholesalePage: {
    pageTitle: 'Portale Ingrosso',
    pageSubtitle: 'Centro Rivenditori & Ingrosso FentyBarefoot',
    heroBadge: 'Programma Rivenditore Autorizzato',
    heroTitle: 'Catalogo Prodotti Ingrosso',
    heroDesc: 'Ordina i nostri prodotti grounding barefoot all\'ingrosso. Prezzi speciali per ordini da 50 unità in su.',
    loginTitle: 'Accesso Rivenditore',
    loginSubtitle: 'Accedi per vedere i prezzi ingrosso',
    loginUsername: 'Nome utente',
    loginPassword: 'Password',
    loginBtn: 'Accedi',
    loginError: 'Nome utente o password non validi',
    logoutBtn: 'Esci',
    loggedInAs: 'Accesso come:',
    priceHidden: 'Accedi per vedere il prezzo',
    priceHiddenShort: 'Accesso rivenditore richiesto',
    unlockPrices: 'Accedi come rivenditore per vedere i prezzi',
    filterAll: 'Tutto',
    filterWomen: 'Donna',
    filterMen: 'Uomo',
    filterUnisex: 'Unisex',
    filterShoes: 'Scarpe',
    filterClothing: 'Abbigliamento',
    categoryLabel: 'Categoria',
    genderLabel: 'Genere',
    qty50: '50 Unità',
    qty100: '100 Unità',
    qty500: '500 Unità',
    qtyLabel: 'Quantità ordine',
    pricePerUnit: 'Prezzo unitario',
    totalPrice: 'Prezzo totale',
    requestBtn: 'Richiedi preventivo',
    requestNote: 'Il prezzo viene determinato dalla quantità. Stai inviando una richiesta di preventivo.',
    requestModalTitle: 'Modulo richiesta ingrosso',
    requestModalDesc: 'Invia la tua richiesta di ordine all\'ingrosso per il prodotto selezionato.',
    requestProduct: 'Prodotto',
    requestQty: 'Quantità',
    requestName: 'Nome completo',
    requestEmail: 'E-mail',
    requestPhone: 'Telefono',
    requestCompany: 'Nome azienda',
    requestMessage: 'Note',
    requestSend: 'Invia richiesta',
    requestClose: 'Chiudi',
    requestSuccess: 'La tua richiesta è stata inviata! Ti contatteremo a breve.',
    stockInfo: 'Stock',
    material: 'Materiale',
    sizes: 'Taglie',
    colors: 'Colori',
    images: 'Immagini',
    priceTierTitle: 'Fasce di prezzo ingrosso',
    priceTier50: '50+ unità',
    priceTier100: '100+ unità',
    priceTier500: '500+ unità',
    sortBy: 'Ordina per',
    sortDefault: 'Predefinito',
    sortPriceLow: 'Prezzo: Basso ad Alto',
    sortPriceHigh: 'Prezzo: Alto a Basso',
    noProducts: 'Nessun prodotto trovato per questo filtro.',
    viewImages: 'Immagine',
    of: 'di',
    totalProducts: 'prodotti',
    loginRequired: 'Accesso rivenditore richiesto per i prezzi ingrosso',
    loginRequiredDesc: 'Accedi con il tuo account rivenditore per vedere i prezzi.',
    dealerLoginBox: 'Pannello accesso rivenditore',
    headerTagline: 'Il più grande centro ingrosso Grounding Barefoot della Turchia',
    statsProducts: 'Varietà prodotti',
    statsCountries: 'Rivenditori paese',
    statsYears: 'Anni di esperienza',
    statsDealers: 'Rivenditori attivi',
  },

  footerNotif: {
    liveBadge: 'Notifiche in tempo reale',
    paused: '⏸ In pausa',
    liveStatus: '▶ Live',
    buyAction: 'ha acquistato',
    favAction: 'ha aggiunto ai preferiti',
    cartStatAction: 'persone hanno nel carrello',
    favStatAction: 'persone hanno aggiunto ai preferiti',
    labelBuy: 'Acquistato',
    labelFav: 'Preferito',
    labelCart: 'Nel carrello',
    labelLive: 'Live',
    justNow: 'Proprio ora',
    min1: '1 min fa',
    min2: '2 min fa',
    min3: '3 min fa',
    min5: '5 min fa',
    min7: '7 min fa',
    prod1: 'Sandali Intrecciati Dorati',
    prod2: 'Pantofole in Pelle',
    prod3: 'Vestito Maxi Boho',
    prod4: 'Sandali con Tacco e Lacci',
    prod5: 'Abito Avvolgente in Lino',
    prod6: 'Sandali con Plateau',
    prod7: 'Pantofole in Pelle Vegana',
    prod8: 'Vestito Midi Floreale',
    prod9: 'Sandali da Uomo',
    prod10: 'Camicia in Lino da Uomo',
    prod11: 'Sandali Piatti in Paglia',
    prod12: 'Sandali in Corda',
    prod13: 'Mules con Tacco',
    prod14: 'Set di Braccialetti Dorati',
    prod15: 'Set Combinato Estivo',
    prod16: 'Combinato Estivo da Uomo',
    prod17: 'Borsa in Pelle + Sandali',
    prod18: 'Borsa Boho + Pantofole',
    prod19: 'Combinato con Abito Estivo',
    prod20: 'Set da Spiaggia',
    prod21: 'Set Bikini Colorato',
    prod22: 'Borsa da Spiaggia in Paglia',
    prod23: 'Occhiali da Sole',
    prod24: 'Vestito Estivo in Cotone',
    prod25: 'Cintura in Pelle',
    prod26: 'Sandali Intrecciati',
    prod27: 'Blusa Floreale',
    prod28: 'Pantaloncini in Lino',
    prod29: 'Collana in Argento',
    prod30: 'Borsa in Rattan',
  },

  memberPanel: {
    breadcrumbHome: 'Home',
    breadcrumbPanel: 'Il mio account',
    loading: 'Caricamento...',
    memberSince: 'Membro dal:',
    menu: 'Menu',
    logout: 'Disconnetti',
    logoutConfirmTitle: 'Vuoi disconnetterti?',
    logoutConfirmDesc: 'Verrai disconnesso dal tuo account in modo sicuro.',
    logoutCancel: 'Annulla',
    tabOrders: 'I miei ordini',
    tabReturns: 'I miei resi',
    tabCoupons: 'I miei buoni sconto',
    tabSupport: 'I miei ticket supporto',
    tabInvoices: 'Le mie fatture',
    tabAddress: 'I miei indirizzi',
    tabProfile: 'Il mio profilo',
    addressTabTitle: 'Dati Indirizzo & Contatto',
    addressTabSubtitle: 'Gestisci il tuo indirizzo di consegna e i dati personali',
    deliveryAddressSection: 'Indirizzo di consegna',
    addressDefault: 'Indirizzo predefinito',
    editInfoBtn: 'Modifica',
    saveInfoBtn: 'Aggiorna',
    cancelInfoBtn: 'Annulla',
    saveInfoSuccess: 'Informazioni aggiornate con successo!',
    addressFullName: 'Nome completo',
    addressPhone: 'Telefono',
    addressEmail: 'E-mail',
    addressLine: 'Indirizzo',
    addressCity: 'Città',
    addressPostalCode: 'Codice postale',
    addressCountry: 'Paese',
    addressInfoNote: 'I tuoi dati vengono salvati in modo sicuro. Le modifiche all\'indirizzo si applicano solo ai nuovi ordini.',
    trackingPanelTitle: 'Tracciamento spedizione',
    trackingNumberLabel: 'Numero di tracciamento',
    copyTrackingBtn: 'Copia',
    trackingCopied: 'Copiato!',
    upsTrackBtn: 'Traccia su UPS.com',
    upsWarning: 'Prima copia il numero di tracciamento, poi apri UPS.com e incollalo nella barra di ricerca per seguire il tuo pacco in tempo reale.',
    profileTitle: 'Impostazioni profilo',
    profileSubtitle: 'Gestisci la tua foto profilo e la sicurezza dell\'account',
    profilePhotoSection: 'Foto profilo',
    uploadPhotoBtn: 'Carica foto',
    changePhotoBtn: 'Modifica',
    removePhotoBtn: 'Rimuovi',
    photoFormats: 'JPG o PNG. Max 5MB.',
    photoUpdated: 'Foto profilo aggiornata!',
    photoRemoved: 'Foto rimossa',
    photoTooLargeError: 'Il file non può superare 5MB',
    passwordSectionTitle: 'Cambia password',
    currentPassword: 'Password attuale',
    currentPasswordPlaceholder: 'Inserisci la password attuale',
    newPassword: 'Nuova password',
    newPasswordPlaceholder: 'Inserisci la nuova password',
    confirmNewPassword: 'Conferma nuova password',
    confirmNewPasswordPlaceholder: 'Reinserisci la nuova password',
    changePasswordBtn: 'Aggiorna password',
    passwordUpdated: 'La tua password è stata aggiornata con successo!',
    errCurrentPassword: 'La password attuale non è corretta',
    errPasswordMismatch: 'Le password non corrispondono',
    errPasswordTooShort: 'La password deve essere di almeno 6 caratteri',
    errCouponMinOrder: 'L\'importo minimo dell\'ordine per questo coupon è {{amount}}',
    savingLabel: 'Salvataggio...',
    invoicePreviewBtn: 'Anteprima',
    pdfModalTitle: 'Anteprima fattura',
    pdfModalClose: 'Chiudi',
    pdfModalPrint: 'Stampa / Salva come PDF',
    orderDetailBtn: 'Dettagli ordine',
    orderDetailTitle: 'Dettagli ordine',
    orderDetailClose: 'Chiudi',
    reorderBtn: 'Riordina',
    reorderSuccess: 'Articoli aggiunti al carrello!',
    reorderSuccessDesc: 'Tutti gli articoli del tuo ordine sono stati aggiunti al carrello.',
    reorderAdded: 'Aggiunto!',
    orderProgress: 'Stato ordine',
    step1Title: 'In preparazione',
    step2Title: 'Spedito',
    step3Title: 'Consegnato',
    orderLabel: 'Ordine:',
    requestDateLabel: 'Data richiesta:',
    reasonColLabel: 'Motivo:',
    refundAmount: 'Importo rimborso',
    refundMethod: 'Metodo rimborso',
    estimatedRefundDate: 'Data rimborso stimata',
    pendingInfo: 'La tua richiesta è in esame. Ti risponderemo entro 24 ore.',
    noReturns: 'Ancora nessuna richiesta di reso',
    noReturnsDesc: 'Puoi inviare richieste di reso / cambio nella sezione I miei ordini.',
    returnsPolicyTitle: 'Politica reso & cambio',
    returnsPolicyDesc: 'Puoi restituire prodotti non utilizzati entro 30 giorni dalla consegna gratuitamente. Le spese di spedizione per il reso sono a nostro carico.',
    couponsTitle: 'I miei buoni sconto',
    activeCouponsCount: '{{count}} buoni attivi',
    used: 'Usato',
    copy: 'Copia',
    copied: 'Copiato',
    activeCoupons: 'Buoni attivi',
    usedCoupons: 'Buoni usati',
    minOrderLabel: 'Min.',
    validUntilLabel: 'Fino al:',
    supportTitle: 'I miei ticket supporto',
    supportCount: '{{count}} ticket',
    newTicketBtn: 'Nuovo ticket',
    newTicketFormTitle: 'Crea nuovo ticket supporto',
    ticketCreatedMsg: 'Il tuo ticket supporto è stato creato con successo.',
    subjectLabel: 'Oggetto *',
    subjectPlaceholder: 'Descrivi brevemente l\'argomento',
    supportCategoryLabel: 'Categoria',
    supportCategoryPlaceholder: 'Seleziona...',
    supportCat1: 'Ordine & Pagamento',
    supportCat2: 'Spedizione & Consegna',
    supportCat3: 'Reso & Cambio',
    supportCat4: 'Domanda sul prodotto',
    supportCat5: 'Account & Iscrizione',
    supportCat6: 'Generale',
    messageLabel: 'Il tuo messaggio *',
    messagePlaceholder: 'Descrivi il tuo problema o richiesta in dettaglio...',
    submitTicketBtn: 'Invia ticket',
    supportStatusOpen: 'Aperto',
    supportStatusAnswered: 'Risposto',
    supportStatusClosed: 'Chiuso',
    priorityNormal: 'Normale',
    priorityHigh: 'Alta',
    priorityLow: 'Bassa',
    createdAtLabel: 'Creato il:',
    youLabel: 'Tu',
    supportTeamLabel: '🛟 Team supporto',
    replyPlaceholder: 'Scrivi la tua risposta...',
    invoicesTitle: 'Le mie fatture',
    invoicesCount: '{{count}} fatture',
    downloadBtn: 'Scarica',
    invoiceStatusPaid: 'Pagato',
    invoiceStatusPending: 'In attesa',
    invoiceStatusCancelled: 'Annullato',
    invoiceHeaderLabel: 'FATTURA',
    billingAddressLabel: 'Indirizzo di fatturazione',
    productColLabel: 'Prodotto',
    qtyColLabel: 'Qtà',
    unitPriceColLabel: 'Prezzo unitario',
    totalColLabel: 'Totale',
    subtotalLabel: 'Subtotale',
    shippingCostLabel: 'Spedizione',
    taxLabel: 'Tassa',
    grandTotalLabel: 'Totale generale',
    downloadInvoiceBtn: 'Scarica fattura',
    orderRefLabel: 'Ordine:',
    saveAddressLabel: 'Salva questo indirizzo per il prossimo ordine',
    savedAddressTitle: 'Il tuo indirizzo salvato',
    useSavedAddress: 'Usa indirizzo salvato',
  },
  saveAddressLabel: 'Salva questo indirizzo per il prossimo ordine',
  savedAddressTitle: 'Il tuo indirizzo salvato',
  useSavedAddress: 'Usa indirizzo salvato',

  story: {
    swipeHint: 'Scorri',
    productTaggedLabel: 'prodotti taggati — tocca per esplorare',
    goToProduct: 'Vai al prodotto',
    discountLabel: 'sconto',
    followInstagram: 'Segui su Instagram • @fentybarefoot',
    stories: {
      s1: { title: '🔥 Più Venduti', subtitle: "Le superstar della settimana sono qui — non perderle!", badge: 'TOP SELLER', cta: 'Vedi i popolari' },
      s2: { title: '✨ Sandali Nuova Stagione 2026', subtitle: 'La nuova collezione artigianale è arrivata', badge: 'NUOVA STAGIONE 2026', cta: 'Sandali Donna' },
      s3: { title: '👗 Collezione Donna', subtitle: 'Unisci eleganza e libertà', badge: 'COLLEZIONE', cta: 'Moda Donna' },
      s4: { title: '🎉 Super Saldi', subtitle: 'Fino al 70% di sconto — scorte in esaurimento!', badge: '70% DI SCONTO', cta: 'Vedi le offerte' },
      s5: { title: '👟 Collezione Uomo', subtitle: 'Stile maschile moderno — naturale e comodo', badge: 'UOMO', cta: 'Prodotti Uomo' },
      s6: { title: '🌿 Moda Sostenibile', subtitle: 'Produzione eco-friendly, sensazione di lusso', badge: 'ECO', cta: 'La Nostra Storia' },
      s7: { title: '👜 Accessori & Borse', subtitle: 'I dettagli che completano il tuo stile', badge: 'NUOVO', cta: 'Collezione Accessori' },
      s8: { title: '🎁 Set Combinati', subtitle: 'Insieme più conveniente — set a prezzi speciali', badge: 'OFFERTA COMBO', cta: 'Scopri i set' },
      s9: { title: '📸 Noi su Instagram', subtitle: '@fentybarefoot — Unisciti alla nostra comunità', badge: 'SOCIAL', cta: 'Segui su Instagram' },
    },
  },

  fitGuide: {
    title: 'Guida alle Taglie',
    subtitle: 'Confronta per trovare la vestibilità migliore per te',
    infoNote: 'In caso di dubbio, consigliamo',
    infoHighlight: 'la Vestibilità Ampia',
    infoNoteEnd: '— si adatta liberamente al corpo e si adatta a tutti.',
    wideLabel: 'Vestibilità Ampia',
    wideFit: 'Comodo & Movimento Libero',
    wideDesc: 'Un taglio traspirante che si adatta liberamente al corpo. Ideale per uso quotidiano e giornate lunghe.',
    wideFeature1: 'Spazio extra nella zona spalle e braccia',
    wideFeature2: 'Vita rilassata, taglio non restrittivo',
    wideFeature3: 'Rimane comodo per ore',
    wideFeature4: 'Non limita il movimento',
    wideFeature5: 'Si adatta a ogni tipo di corpo',
    wideBest: 'Uso quotidiano, viaggi, abbigliamento casual',
    narrowLabel: 'Vestibilità Stretta',
    narrowFit: 'Aderente & Silhouette Chic',
    narrowDesc: 'Un taglio strutturato e aderente che valorizza la tua figura. Perfetto per le occasioni speciali.',
    narrowFeature1: 'Si adatta perfettamente a spalle e petto',
    narrowFeature2: 'Abbraccia dolcemente la vita',
    narrowFeature3: 'Look elegante e curato',
    narrowFeature4: 'Enfatizza i contorni del corpo',
    narrowFeature5: 'Offre una silhouette snella e raffinata',
    narrowBest: 'Occasioni speciali, eventi aziendali, cene',
    compareTitle: 'Confronto Rapido',
    featureHeader: 'Caratteristica',
    compareWide: 'Vestibilità Ampia',
    compareNarrow: 'Vestibilità Stretta',
    row1Label: 'Comfort', row1Wide: '⭐⭐⭐⭐⭐', row1Narrow: '⭐⭐⭐⭐',
    row2Label: 'Silhouette', row2Wide: 'Fluente & Libera', row2Narrow: 'Definita & Aderente',
    row3Label: 'Libertà di Movimento', row3Wide: 'Massima', row3Narrow: 'Moderata',
    row4Label: 'Miglior Utilizzo', row4Wide: 'Quotidiano & Casual', row4Narrow: 'Speciale & Formale',
    row5Label: 'Adattamento al Corpo', row5Wide: 'Ogni tipo di corpo', row5Narrow: 'In base alla preferenza',
    bestLabel: 'Ottimo per:',
    liveSupportText: 'Non sei sicuro di quale vestibilità sia quella giusta?',
    liveSupportLink: 'supporto live',
    liveSupportEnd: 'Il nostro team è felice di aiutarti.',
    shoe: {
      title: 'Guida alla Forma della Scarpa',
      subtitle: 'Scegli la forma giusta in base alla larghezza della punta',
      infoNote: 'Le nostre scarpe barefoot hanno una',
      infoHighlight: 'forma anatomica',
      infoNoteEnd: '— le dita si allargano naturalmente senza compressione.',
      barefootLabel: 'Forma Barefoot',
      barefootTagline: 'Anatomica & Punta Larga',
      barefootDesc: 'Punta molto larga, taglio anatomico. Le dita si muovono liberamente senza stringere.',
      barefootF1: 'Punta più larga disponibile',
      barefootF2: 'Le dita si allargano naturalmente',
      barefootF3: 'Massimo comfort per tutto il giorno',
      barefootF4: 'Supporta la postura naturale del piede',
      barefootBest: 'Uso quotidiano, viaggi, vita sana',
      standartLabel: 'Forma Standard',
      standartTagline: 'Normale & Equilibrata',
      standartDesc: 'Taglio classico equilibrato con punta media — adatto alla maggior parte dei tipi di piede.',
      standartF1: 'Punta più stretta disponibile',
      standartF2: 'Vestibilità perfetta per piedi snelli',
      standartF3: 'Aspetto elegante e raffinato',
      standartF4: 'Ottimo per occasioni speciali',
      darBest: 'Occasioni speciali, eventi formali',
    },
  },

  careGuide: {
    tabDescription: 'Descrizione Prodotto',
    tabMaterial: 'Info Tessuto',
    tabCare: 'Istruzioni per la Cura',
    tabLeather: 'Cura del Cuoio',
    tabSole: 'Caratteristiche Suola',
    compositionTitle: 'Composizione del Materiale',
    mainFabricLabel: 'Tessuto Principale',
    mainFabricVal: '100% Lino Biologico',
    liningLabel: 'Fodera',
    liningVal: '100% Cotone Biologico',
    certLabel: 'Certificazione',
    certVal: 'Certificato GOTS Biologico',
    propertiesTitle: 'Proprietà del Tessuto',
    prop1: 'Struttura traspirante e leggera',
    prop2: 'Proprietà assorbenti dell\'umidità',
    prop3: 'Struttura in filo naturale, ipoallergenico',
    prop4: 'Resistente ai raggi UV, duraturo',
    prop5: 'Eco-compatibile, di origine naturale',
    washLabel: 'Lavaggio',
    washVal: '30°C Delicato',
    washNote: 'Lavare in acqua fredda in ciclo delicato',
    dryLabel: 'Asciugatura',
    dryVal: 'Asciugatura all\'Aria',
    dryNote: 'Asciugare all\'ombra, ambiente naturale',
    ironLabel: 'Stiratura',
    ironVal: 'Calore Medio ••',
    ironNote: 'Usare panno umido o ferro a vapore',
    bleachLabel: 'Candeggio',
    bleachVal: 'Senza Cloro',
    bleachNote: 'Usare detersivo delicato a base di ossigeno',
    dryCleanLabel: 'Lavaggio a Secco',
    dryCleanVal: 'Non Consigliato',
    dryCleanNote: 'Non lavare a secco',
    tipsTitle: 'Consigli di Cura degli Esperti',
    tip1: 'Possibile leggero rilascio di colore al primo lavaggio — lavare separatamente',
    tip2: 'Le leggere grinze nel lino sono normali — stirare a vapore',
    tip3: 'Lavare i colori scuri al rovescio',
    tip4: 'Non mettere nell\'asciugatrice — la forma può deformarsi',
    orgCertNote: 'Cos\'è la Certificazione GOTS?',
    orgCertDesc: 'Global Organic Textile Standard — lo standard biologico più rigoroso del settore tessile, che copre l\'intero processo produttivo.',
    leatherWarningTitle: 'Avviso Suola in Cuoio',
    leatherWarningText: 'Le suole in cuoio non sono adatte a umidità eccessiva. Il contatto prolungato con pioggia, pozzanghere o superfici bagnate può danneggiare il cuoio.',
    rubberTitleSection: 'Suola in Gomma — Sicura in Tutte le Condizioni',
    rubberDesc: 'Le suole in gomma resistono all\'acqua, al freddo invernale e alle superfici bagnate. La scelta perfetta per pioggia, neve e terreni impegnativi.',
    leatherCare1Label: 'Umidità',
    leatherCare1Val: 'Proteggere',
    leatherCare1Note: 'Tenere lontano da pioggia e acqua',
    leatherCare2Label: 'Pulizia',
    leatherCare2Val: 'Panno Umido',
    leatherCare2Note: 'Evitare detergenti forti',
    leatherCare3Label: 'Conservazione',
    leatherCare3Val: 'Ventilato',
    leatherCare3Note: 'Lontano dalla luce solare diretta',
    leatherCare4Label: 'Condizionatore',
    leatherCare4Val: 'Raccomandato',
    leatherCare4Note: 'Usare crema nutriente per cuoio',
    leatherCare5Label: 'Asciugatura',
    leatherCare5Val: 'Aria',
    leatherCare5Note: 'No calore o asciugacapelli',
    leatherTipsTitle: 'Consigli Cura del Cuoio',
    leatherTip1: 'Non esporre mai il cuoio bagnato al calore diretto — asciugare all\'ombra naturalmente',
    leatherTip2: 'Applicare crema nutriente o olio naturale una volta al mese',
    leatherTip3: 'Conservare in un sacchetto anti-polvere quando non in uso',
    leatherTip4: 'Pulire immediatamente le macchie con un panno umido',
    soleFeature1Title: 'Suola in Cuoio',
    soleFeature1Badge: 'Classico & Naturale',
    soleFeature1Desc: 'Suola artigianale in cuoio vero — traspirante, si modella al piede e sviluppa carattere nel tempo.',
    soleFeature1Pro1: 'Traspirante e sensazione naturale',
    soleFeature1Pro2: 'Si adatta alla forma del piede',
    soleFeature1Pro3: 'Aspetto elegante e raffinato',
    soleFeature1Con1: 'Evitare esposizione eccessiva all\'umidità',
    soleFeature2Title: 'Suola in Gomma',
    soleFeature2Badge: 'Durevole & Per Ogni Tempo',
    soleFeature2Desc: 'Suola antiscivolo in gomma offre grip e protezione eccellenti su superfici bagnate, fredde e dure.',
    soleFeature2Pro1: 'Resistente all\'acqua e all\'inverno',
    soleFeature2Pro2: 'Sicurezza antiscivolo su superfici dure',
    soleFeature2Pro3: 'Adatta a tutte e quattro le stagioni',
    soleFeature3Title: 'Rame + Grounding',
    soleFeature3Badge: 'Effetto Grounding',
    soleFeature3Desc: 'Dettagli conduttori in rame creano una connessione di messa a terra con la terra ad ogni passo.',
    soleFeature3Pro1: 'Effetto scientifico di messa a terra',
    soleFeature3Pro2: 'Sentire l\'energia della terra',
    soleFeature3Pro3: 'Contribuisce alla riduzione dello stress',
    soleCompareTitle: 'Confronto Suole',
    soleCompareName: 'Caratteristica',
    soleCompareWater: 'Resistenza all\'acqua',
    soleCompareWinter: 'Prestazioni invernali',
    soleCompareGrip: 'Aderenza al suolo',
    soleCompareBreath: 'Traspirabilità',
    soleCompareGrounding: 'Messa a Terra',
  },

  productFAQ: {
    badge: 'FAQ Prodotto',
    title: 'Domande Frequenti',
    subtitle: 'Le domande più comuni su questo prodotto',
    q1: 'Come trovo la mia taglia?',
    a1: 'Consigliamo di usare la nostra guida alle taglie. Se sei tra due taglie, scegli la più grande — resi e cambi gratuiti disponibili.',
    q2: 'Quali materiali vengono utilizzati?',
    a2: 'I nostri prodotti sono realizzati in lino e cotone biologico certificato GOTS. Nessun colorante chimico — materiali naturali, ipoallergenici e sostenibili.',
    q3: 'Quando arriverà il mio ordine?',
    a3: 'Il tuo ordine viene preparato in 1-2 giorni lavorativi. 3-5 giorni in Turchia, 6-12 giorni internazionalmente. Spedizione gratuita applicabile.',
    q4: 'Posso restituire il prodotto?',
    a4: 'Sì! Resi gratuiti entro 30 giorni. Copriamo le spese di spedizione del reso. Prodotto non utilizzato, etichette intatte e confezione originale.',
    q5: 'Quale suola scegliere?',
    a5: 'Per uso quotidiano ed estivo, la suola in cuoio è una scelta elegante e naturale. Per condizioni piovose, invernali o terreni difficili, la suola in gomma è più resistente. Per la messa a terra, scegli Rame + Grounding.',
    q6: 'Vestibilità ampia o stretta?',
    a6: 'In caso di dubbio, consigliamo la vestibilità ampia — si adatta liberamente, va bene a tutte le figure e rimane comoda tutto il giorno.',
    q7: 'Come curo il prodotto?',
    a7: 'Lavaggio in lavatrice a ciclo delicato a 30°C. Leggere grinze nel lino sono normali — stirare a vapore. Usare detersivo senza cloro e asciugare all\'aria.',
    q8: 'Posso personalizzare il mio ordine?',
    a8: 'Assolutamente! Puoi aggiungere un nome personalizzato, un messaggio o una preferenza di colore. Opzioni di confezione regalo disponibili.',
    ctaTitle: 'Hai altre domande?',
    ctaDesc: 'Il nostro team di supporto è disponibile 24/7.',
    ctaBtn: 'Supporto Live',
  },
  relatedProducts: {
    title: 'Prodotti Correlati',
    subtitle: 'Alternative della stessa categoria che potrebbero piacerti',
    freeShipping: 'Gratuito',
    sold: 'venduti',
    viewProduct: 'Vedi prodotto',
    viewAll: 'Vedi tutti i prodotti',
  },
  alsoBought: {
    title: 'I clienti hanno acquistato anche',
    subtitle: 'I prodotti più scelti dai clienti che hanno acquistato questo articolo',
    liveBadge: 'Di tendenza ora',
    trending: 'Tendenza',
    soldTogether: 'persone hanno acquistato insieme',
    quickView: 'Anteprima rapida',
    quickViewLabel: 'Anteprima rapida',
    added: 'Aggiunto',
    trustSecure: 'Pagamento sicuro',
    trustShipping: 'Spedizione gratuita',
    trustReturn: 'Reso 30 giorni',
    qvDiscount: 'Sconto',
    qvSave: 'Risparmio',
    qvReviews: 'recensioni',
    qvAddToCart: 'Aggiungi al carrello',
    qvGoToProduct: 'Vai alla pagina prodotto',
    qvNote: 'Visita la pagina prodotto per tutte le opzioni e i dettagli.',
  },
  igPopup: {
    title: '🎉 Ottieni il 60% di sconto',
    description: 'Seguici su Instagram, metti like a 3 post, commenta 3 post e inviaci "CODE" via DM!',
    step1: 'Seguici: @zenciv.store',
    step2: 'Metti like a 3 post',
    step3: 'Commenta 3 post',
    step4: 'Invia "CODE" via DM',
    usernamePlaceholder: 'Il tuo username Instagram',
    emailPlaceholder: 'Il tuo indirizzo email',
    goToInstagram: 'Vai su Instagram',
    completed: 'Ho completato – Invia DM',
    sending: 'Invio in corso...',
    trustNote: 'Niente spam. Solo sconti e aggiornamenti.',
    errorInstagram: 'Il nome utente Instagram è obbligatorio.',
    errorEmail: 'Inserisci un indirizzo email valido.',
    successTitle: 'Ottimo, grazie!',
    successText: 'Una volta verificata la tua attività, ti invieremo il codice sconto 60% via DM.',
    successDiscount: 'Codice 60% in arrivo via DM',
    sendDM: 'Invia DM',
    continueShopping: 'Continua gli acquisti',
    neverShow: 'Non mostrare più',
  },

  barefootHealth: {
    badgeLabel: 'Approvato dal Podologo',
    verified: 'Ricerca Scientifica',
    title: 'Vantaggi per la Salute del Barefoot',
    subtitle: 'Tecnologia barefoot raccomandata dai podologi — la scelta più naturale per i tuoi piedi.',
    more: 'altri',
    cta: 'Vedi Tutti i Vantaggi per la Salute',
    popupTitle: 'Vantaggi per la Salute della Tecnologia Barefoot',
    popupSubtitle: 'La scienza incontra la natura — vantaggi comprovati per la salute dei tuoi piedi',
    podiatrist: 'Podologo',
    benefitsTitle: '6 Principali Vantaggi per la Salute',
    benefits: [
      'Allargamento Naturale delle Dita',
      'Equilibrio & Coordinazione Migliorati',
      'Rafforzamento Muscolare',
      'Salute Articolare',
      'Postura di Cammino Naturale',
      'Adattamento al Suolo',
    ],
    benefitDescs: [
      'La scatola per le dita larga consente alle dita di allargarsi naturalmente nella loro posizione anatomica.',
      'La suola minima aumenta la propriocezione, migliorando equilibrio e coordinazione.',
      'I muscoli del piede, del polpaccio e dell\'anca lavorano più naturalmente e si rafforzano.',
      'La pressione articolare ridotta supporta la salute delle ginocchia e delleanche a lungo termine.',
      'Il punto di impacto del tallone si riduce, supportando un\'andatura naturale sull\'avampiede.',
      'La sensazione del terreno aumenta, sviluppando la connessione cervello-piede.',
    ],
    doctorQuote: 'Le scarpe barefoot sono tra le opzioni anatomicamente più appropriate per il piede. La scatola per le dita larga consente un allargamento naturale mentre la suola minima migliora la propriocezione. A lungo termine, può prevenire alluce valgo, dita a martello e fascite plantare.',
    warningsTitle: 'Rischi delle Calzature Tradizionali',
    warnings: [
      'La compressione delle dita può causare alluce valgo e dita a martello',
      'I tacchi alti alterano il centro di gravità del corpo',
      'Il supporto eccessivo indebolisce i muscoli del piede',
      'La scatola per le dita stretta può causare compressione nervosa',
      'Le suole spesse bloccano il feedback sensoriale del suolo',
      'Possono svilupparsi disturbi dell\'andatura a lungo termine',
    ],
    anatomyTitle: 'Barefoot vs Tradizionale: Confronto Anatomico',
    anatomyBarefoot: 'Barefoot — Naturale & Sano',
    anatomyTraditional: 'Tradizionale — Compressione & Pressione',
  },

  groundingSole: {
    headerTitle: 'Suola Rame + Messa a Terra',
    headerSubtitle: 'Connessione energetica con la natura ad ogni passo',
    scienceBadge: 'Evidenza Scientifica',
    diagramFoot: 'Piede',
    diagramCopper: 'Filo di Rame',
    diagramIons: 'Ioni Negativi',
    diagramSole: 'Suola di Rame',
    diagramEarth: 'Connessione Terra',
    howItWorks: 'Come Funziona?',
    step1Title: 'Conduttività del Rame',
    step1Desc: 'Sottili fili di rame nella suola collegano il tuo piede direttamente al campo elettromagnetico della terra. Il rame è uno dei migliori conduttori naturali.',
    step2Title: 'Contatto con il Suolo',
    step2Desc: 'Quando la suola tocca il suolo durante la camminata, inizia il flusso di elettroni liberi — l\'equivalente scientifico del camminare scalzi sulla terra naturale.',
    step3Title: 'Flusso di Ioni Negativi',
    step3Desc: 'Gli ioni negativi che passano dal suolo al corpo neutralizzano i radicali liberi, riducono l\'infiammazione e supportano l\'energia cellulare.',
    benefitsTitle: 'Benefici per la Salute',
    benefit1: 'Riduce l\'infiammazione',
    benefit2: 'Migliora la qualità del sonno',
    benefit3: 'Neutralizzazione radicali liberi',
    benefit4: 'Abbassa stress & cortisolo',
    benefit5: 'Migliora la circolazione',
    benefit6: 'Supporto al sistema immunitario',
    stat1: 'Studi Scientifici',
    stat2: 'Utenti Soddisfatti',
    stat3: 'Hanno Sentito la Differenza',
    quoteText: 'La messa a terra stabilizza elettricamente il corpo. La considero un intervento naturale contro l\'infiammazione cronica, lo stress e i problemi del sonno.',
    quoteAuthor: 'Dr. Marco Ferretti',
    quoteRole: 'Podologo & Specialista della Salute del Piede',
  },
  personalizationInlineTitle: 'Personalizzazione',
  personalizationInlineLine1: 'Puà essere indossato senza calze, comodo e sano.',
  personalizationInlineLine2: "Per misurazioni accurate, puoi scrivere le misure del tuo piede scalzo (lunghezza e larghezza) in centimetri in quest'area. Esempio (24,5 CM x 9 CM)",
  personalizationInlineLine3: 'Verrà prodotto come desideri, largo o stretto.',
  measureGuide: {
    btnLabel: 'Guida alle Misure',
    title: 'Guida alla Misurazione del Piede',
    subtitle: 'Misurazione a piede nudi — in cm',
    diagramLabel: 'Diagramma di Misurazione',
    lengthLabel: 'LUNGHEZZA',
    widthLabel: 'LARGHEZZA',
    toeWidthLabel: 'LARG. DITA',
    example: 'Esempio:',
    stepsTitle: 'Come Misurare?',
    step1Title: 'Posiziona carta bianca',
    step1Desc: 'Posiziona un foglio di carta bianca su una superficie piana. Togli i calzini e mettiti in piedi sulla carta.',
    step2Title: 'Traccia il tuo piede',
    step2Desc: 'Tenendo la penna dritta, traccia con attenzione il contorno del tuo piede. Includi il tallone e il dito più lungo.',
    step3Title: 'Misura la lunghezza',
    step3Desc: 'Misura la distanza dal tallone alla punta del dito più lungo in centimetri.',
    step4Title: 'Misura la larghezza',
    step4Desc: "Misurare orizzontalmente nel punto più largo del piede (all'altezza dell'avampiede).",
    tipLabel: 'Suggerimento:',
    tip: 'Se i tuoi piedi sono di dimensioni diverse, usa il più grande. Inserisci la tua misura nel campo di personalizzazione nel formato "24,5 CM × 9 CM".',
    gotIt: 'Capito, Chiudi',
  },

  categories: {
    'women-clothing': 'Abbigliamento Donna',
    'women-shoes': 'Scarpe Donna',
    'women-slippers': 'Pantofole Donna',
    'women-sandals': 'Sandali Donna',
    'women-combo': 'Combo Donna',
    'women-clothing-tshirt': 'T-Shirt Donna',
    'women-clothing-pants': 'Pantaloni Donna',
    'women-clothing-dress': 'Abiti Donna',
    'women-clothing-kimono': 'Kimono Donna',
    'women-clothing-crop': 'Crop Top Donna',
    'women-clothing-shirt': 'Camicette Donna',
    'women-clothing-skirt': 'Gonne Donna',
    'women-clothing-shorts': 'Pantaloncini Donna',
    'women-clothing-set': 'Set Donna',
    'women-clothing-suit': 'Completi Donna',
    'men-clothing': 'Abbigliamento Uomo',
    'men-shoes': 'Scarpe Uomo',
    'men-slippers': 'Pantofole Uomo',
    'men-sandals': 'Sandali Uomo',
    'men-combo': 'Combo Uomo',
    'men-clothing-tshirt': 'T-Shirt Uomo',
    'men-clothing-pants': 'Pantaloni Uomo',
    'men-clothing-shirt': 'Camicie Uomo',
    'men-clothing-shorts': 'Pantaloncini Uomo',
    'men-clothing-suit': 'Completi Uomo',
    combo: 'Set Combo',
    women: 'Donna',
    men: 'Uomo',
    'vegan-leather': 'Pelle Vegana',
    'genuine-leather': 'Pelle Vera',
  },
};

export default common;
